/* cspell:ignore transphobia */
interface IReferenceIcon { style: 'regular' | 'solid'; name: string; }


/**------------------------------------------------------
 * All Months Enums
 */
export enum EnumMonth {
	January 	= 'january',
	February 	= 'february',
	March 		= 'march',
	April 		= 'april',
	May 		= 'may',
	June 		= 'june',
	July 		= 'july',
	August 		= 'august',
	September 	= 'september',
	October 	= 'october',
	November 	= 'november',
	December 	= 'december'
}


/**------------------------------------------------------
 * All Social Media Holidays Config Data
 * -------------------------------------
 * > source : https://blog.hubspot.com/marketing/social-media-holiday-calendar-2017
 */
export const SOCIAL_MEDIA_HOLIDAYS: ISocialHoliday[] = [
	{
		month: {
			number	 : 0,
			name	 : EnumMonth.January
		},
		majorEvent: {
			name	 : `New Year's Day`,
			icon	 : {
				style: 'solid',
				name : `star-christmas`
			}
		},
		events: [
			{
				dateStr 	 : `January 1st`,
				eventName 	 : `New Year's Day`,
				fromDate	 : new Date('1.1'),
				toDate		 : new Date('1.1'),
				description  : `January 1st is the first day of the year in the Gregorian Calendar. There are 364 days remaining until the end of the year (365 in leap years). This day is known as New Year's Day since the day marks the beginning of the year`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NewYearsDay`],
					keywords : `new year`,
					google   : `New Year's Day`
				}
			},
			{
				dateStr 	 : `January 2nd`,
				eventName 	 : `Science Fiction Day`,
				fromDate	 : new Date('1.2'),
				toDate		 : new Date('1.2'),
				description  : `National Science Fiction Day is unofficially celebrated by many science fiction fans in the United States on January 2, which corresponds with the official birthday of famed science fiction writer Isaac Asimo`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`ScienceFictionDay`],
					keywords : `science fiction`,
					google   : `Science Fiction Day`
				}
			},
			{
				dateStr 	 : `January 4th`,
				eventName 	 : `National Trivia Day`,
				fromDate	 : new Date('1.4'),
				toDate		 : new Date('1.4'),
				description  : `The World famous trivia game, Trivial Pursuit, is thought to have sparked peoples fascination with trivia and competing to see who knows more odd facts about geography, history, art, science, sports and entertainment`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalTriviaDay`],
					keywords : `trivia day`,
					google   : `National Trivia Day`
				}
			},
			{
				dateStr 	 : `January 5th`,
				eventName 	 : `National Bird Day`,
				fromDate	 : new Date('1.5'),
				toDate		 : new Date('1.5'),
				description  : `It is celebrated on January 5th of every year. National Bird Day is an annual holiday with half a million adherents who celebrate through birdwatching, studying birds, and other bird-related activities`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalBirdDay`],
					keywords : `bird day`,
					google   : `National Bird Day`
				}
			},
			{
				dateStr 	 : `January 11th`,
				eventName 	 : `Human Trafficking Awareness Day`,
				fromDate	 : new Date('1.11'),
				toDate		 : new Date('1.11'),
				description  : `January is Human Trafficking Awareness Month, and January 11th is Human Trafficking Awareness Day. Human trafficking is a humanitarian crisis that is a form of modern day slavery. Not only is human trafficking prevalent around the world, but cases of human trafficking are reported in all 50 states`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalBirdDay`],
					keywords : `human trafficking`,
					google   : `Human Trafficking Awareness Day`
				}
			},
			{
				dateStr 	 : `January 11th`,
				eventName 	 : `Clean Off Your Desk Day`,
				fromDate	 : new Date('1.11'),
				toDate		 : new Date('1.11'),
				description  : `This day is an opportunity to begin your new year with a clean and organized workspace. Whether your desk is in a private or shared office, cubicle, home or a make-shift desk on the counter, having your workspace uncluttered and organized will help you work more efficiently. A clean workspace improves productivity and inspires us, too. It often gives us a sense of serenity`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`CleanOffYourDeskDay`],
					keywords : `clean desk`,
					google   : `Clean Off Your Desk Day`
				}
			},
			{
				dateStr 	 : `January 13th`,
				eventName 	 : `National Sticker Day`,
				fromDate	 : new Date('1.13'),
				toDate		 : new Date('1.13'),
				description  : `January 13 is National Sticker Day and it's the perfect day to go crazy with your love of them! The first stickers began as tax and postage stamps in the 1800s, but they have come a long way since then and there are a variety of uses and styles today. There are political stickers, band stickers, and bumper stickers`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalStickerDay`],
					keywords : `sticker day`,
					google   : `National Sticker Day`
				}
			},
			{
				dateStr 	 : `January 15th`,
				eventName 	 : `National Hat Day`,
				fromDate	 : new Date('1.15'),
				toDate		 : new Date('1.15'),
				description  : `Hats have been in the world since at least 3000 BC. This is known because an image of a man wearing a hat that seemed to be made of straw was discovered in a mural from that period of time`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalHatDay`],
					keywords : `hat day`,
					google   : `National Hat Day`
				}
			},
			{
				dateStr 	 : `January 17th`,
				eventName 	 : `Martin Luther King, Jr. Day`,
				fromDate	 : new Date('1.17'),
				toDate		 : new Date('1.17'),
				description  : `Martin Luther King Jr. Day is a federal holiday in the United States marking the birthday of Martin Luther King Jr. It is observed on the third Monday of January each year. Born in 1929, King's actual birthday is January 15. The holiday is similar to holidays set under the Uniform Monday Holiday Act`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`MLKDay`],
					keywords : `martin luther king`,
					google   : `Martin Luther King, Jr. Day`
				}
			},
			{
				dateStr 	 : `January 20th`,
				eventName 	 : `Cheese Lovers Day`,
				fromDate	 : new Date('1.20'),
				toDate		 : new Date('1.20'),
				description  : `National Cheese Lovers Day is a day dedicated to the celebration of the many different types of cheese in the world, but this day is certainly not exclusive to cheese connoisseurs who have strange or exotic tastes. Few foods have as much of a rich and extravagant history as cheese`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`CheeseLoversDay`],
					keywords : `cheese day`,
					google   : `Cheese Lovers Day`
				}
			},
			{
				dateStr 	 : `January 20th`,
				eventName 	 : `Get to Know Your Customers Day`,
				fromDate	 : new Date('1.20'),
				toDate		 : new Date('1.20'),
				description  : `While the origin of Get to Know Your Customers Day is unknown, the significance of its purpose is fully understood. Businesses thrive on the repeated patronage of their customers. Get to Know Your Customers Day is the quarterly reminder that prompts companies to understand the needs and opinions of their customer base`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`GetToKnowYourCustomersDay`],
					keywords : `customers day`,
					google   : `Get to Know Your Customers Day`
				}
			},
			{
				dateStr 	 : `January 21st`,
				eventName 	 : `National Hugging Day`,
				fromDate	 : new Date('1.21'),
				toDate		 : new Date('1.21'),
				description  : `National Hugging Day is an annual event dedicated to hugging. It was created by Kevin Zaborney and occurs annually on January 21st. The day was first celebrated on January 21, 1986 in Clio, Michigan, USA. The holiday is also observed in many other countries`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalHuggingDay`],
					keywords : `hugging day`,
					google   : `National Hugging Day`
				}
			},
			{
				dateStr 	 : `January 22th`,
				eventName 	 : `Chinese New Year`,
				fromDate	 : new Date('1.22'),
				toDate		 : new Date('1.22'),
				description  : `Chinese New Year, Spring Festival or the Lunar New Year, is the festival that celebrates the beginning of a new year on the traditional lunisolar Chinese calendar`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`ChineseNewYear`, `LunarNewYear`],
					keywords : `chinese new year`,
					google   : `Chinese New Year`
				}
			},
			{
				dateStr 	 : `January 24th`,
				eventName 	 : `National Compliment Day`,
				fromDate	 : new Date('1.24'),
				toDate		 : new Date('1.24'),
				description  : `National Compliment Day on January 24th offers a wonderful way to brighten someone's day or to give credit for a job well done! Give an extra compliment annually on January 24th and any time one is deserved. A compliment has a powerful effect. It can instill confidence in a child, or validate someone's hard work`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalComplimentDay`],
					keywords : `compliment day`,
					google   : `National Compliment Day`
				}
			},
			{
				dateStr 	 : `January 25th`,
				eventName 	 : `Opposite Day`,
				fromDate	 : new Date('1.25'),
				toDate		 : new Date('1.25'),
				description  : `The strange and wacky Opposite Day is celebrated on January 25. For those who are into the concept of different timelines, Opposite Day is the closest we can get, giving us a tiny glimpse of what the world will be like if the opposite of everything happened`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`OppositeDay`],
					keywords : `opposite day`,
					google   : `Opposite Day`
				}
			},
			{
				dateStr 	 : `January 28th`,
				eventName 	 : `Data Privacy Day`,
				fromDate	 : new Date('1.28'),
				toDate		 : new Date('1.28'),
				description  : `Data Privacy Day (known in Europe as Data Protection Day) is an international event that occurs every year on 28 January. The purpose of Data Privacy Day is to raise awareness and promote privacy and data protection best practices. It is currently observed in the United States, Canada, Israel and 47 European countries`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`PrivacyAware`],
					keywords : `data privacy`,
					google   : `Data Privacy Day`
				}
			},
			{
				dateStr 	 : `January 31st`,
				eventName 	 : `Community Manager Appreciation Day`,
				fromDate	 : new Date('1.31'),
				toDate		 : new Date('1.31'),
				description  : `People are encouraged to send sincere Thank You notes to their online community managers. People using Twitter include the #CMAD and #CMGR hashtag in their tweets about this event. Many online community managers and vendors in the social media marketplace post blogs in appreciation of their community managers. Cities with large concentrations of Social Media focused businesses, such as Boston, Austin, and San Francisco hold in-person meetup events to celebrate and honor those who represent and support their online communities`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`CMAD`],
					keywords : `community manager`,
					google   : `Community Manager Appreciation Day`
				}
			}
		]
	},
	{
		month: {
			number	 : 1,
			name	 : EnumMonth.February
		},
		majorEvent: {
			name	 : 'Black History Month',
			icon	 : {
				style: 'solid',
				name : `landmark-dome`
			}
		},
		events: [
			{
				dateStr 	 : `February 1st - 28th`,
				eventName 	 : `Black History Month`,
				fromDate	 : new Date('2.1'),
				toDate		 : new Date('2.28'),
				description  : `Black History Month is an annual observance originating in the United States, where it is also known as African-American History Month. ... It began as a way of remembering important people and events in the history of the African diaspora`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`BlackHistory`],
					keywords : `black history`,
					google   : `Black History`
				}
			},
			{
				dateStr 	 : `February 1st - 28th`,
				eventName 	 : `100th Day of School`,
				fromDate	 : new Date('2.1'),
				toDate		 : new Date('2.28'),
				description  : `The actual date varies from school to school, but most classes reach their 100th day sometime between the end of January and mid-February. The day is a symbolic celebration of students' academic and personal achievements of the academic year so far`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`100thDayOfSchool`],
					keywords : `100th Day of School`,
					google   : `100th Day of School`
				}
			},
			{
				dateStr 	 : `February 2nd`,
				eventName 	 : `Groundhog Day`,
				fromDate	 : new Date('2.2'),
				toDate		 : new Date('2.2'),
				description  : `This holiday celebrates 'Punxsutawney Phil', a groundhog who can supposedly forecast the weather`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`GroundhogDay`],
					keywords : `groundhog day`,
					google   : `Groundhog Day`
				}
			},
			{
				dateStr 	 : `February 2nd`,
				eventName 	 : `World Wetlands Day`,
				fromDate	 : new Date('2.2'),
				toDate		 : new Date('2.2'),
				description  : `World Wetlands Day is celebrated each year on 2 February to raise awareness about wetlands. This day also marks the anniversary of the Convention on Wetlands, which was adopted as an international treaty in 1971`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldWetlandsDay`],
					keywords : `wetlands day`,
					google   : `World Wetlands Day`
				}
			},
			{
				dateStr 	 : `February 4th`,
				eventName 	 : `World Cancer Day`,
				fromDate	 : new Date('2.4'),
				toDate		 : new Date('2.4'),
				description  : `World Cancer Day is an international day marked on 4 February to raise awareness of cancer and to encourage its prevention, detection, and treatment. World Cancer Day is led by the Union for International Cancer Control to support the goals of the World Cancer Declaration, written in 2008`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`WorldCancerDay`],
					keywords : `cancer day`,
					google   : `World Cancer Day`
				}
			},
			{
				dateStr 	 : `February 5th`,
				eventName 	 : `National Weatherperson's Day`,
				fromDate	 : new Date('2.5'),
				toDate		 : new Date('2.5'),
				description  : `The day commemorates the birth of John Jeffries in 1744. Jeffries, one of Americas first weather observers, began taking daily weather observations in Boston in 1774 and he took the first balloon observation in 1784`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalWeatherpersonsDay`],
					keywords : `weatherperson`,
					google   : `National Weatherperson's Day`
				}
			},
			{
				dateStr 	 : `February 7th`,
				eventName 	 : `National Send a Card to a Friend Day`,
				fromDate	 : new Date('2.7'),
				toDate		 : new Date('2.7'),
				description  : `National Send A Card To A Friend Day on February 7th reminds us to send friendly cheer through the mail. We do that by sending a note or message on a card to the friends we hold dear. Throughout the year, we often think about our friends`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`SendACardToAFriendDay`],
					keywords : `send card day`,
					google   : `National Send a Card to a Friend Day`
				}
			},
			{
				dateStr 	 : `February 8th`,
				eventName 	 : `National Boy Scouts Day`,
				fromDate	 : new Date('2.8'),
				toDate		 : new Date('2.8'),
				description  : `On February 8 we celebrate National Boy Scout Day to honor those who are trustworthy, loyal, helpful, friendly, courteous, kind, obedient, cheerful, thrifty, brave, clean and reverent. Founded in 1910, by American W.D. Boyce, the Boy Scouts of America has helped shape many of our nation's leaders`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`BoyScoutsDay`],
					keywords : `boy scouts`,
					google   : `National Boy Scouts Day`
				}
			},
			{
				dateStr 	 : `February 9th`,
				eventName 	 : `National Pizza Day`,
				fromDate	 : new Date('2.9'),
				toDate		 : new Date('2.9'),
				description  : `National Pizza Day on February 9th celebrates one of America's all-time favorite foods. Whether it is thin crust, Chicago-style, deep dish, or anything in between, pizza is an American favorite`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalPizzaDay`],
					keywords : `pizza day`,
					google   : `National Pizza Day`
				}
			},
			{
				dateStr 	 : `February 9th`,
				eventName 	 : `Safer Internet Day`,
				fromDate	 : new Date('2.9'),
				toDate		 : new Date('2.9'),
				description  : `Safer Internet Day is observed every year on the second day of the second week of February with an aim to provide safer and better internet, where every user gets to use the internet responsibly and without getting their data leaked. The day is being celebrated in around 15 countries across the world today`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`SID`],
					keywords : `internet day`,
					google   : `Safer Internet Day`
				}
			},
			{
				dateStr 	 : `February 11th`,
				eventName 	 : `Inventors Day`,
				fromDate	 : new Date('2.11'),
				toDate		 : new Date('2.11'),
				description  : `Inventors' Day is a day of the year set aside by a country to recognize the contributions of inventors. Not all countries recognize Inventors' Day. Those countries which do recognize an Inventors' Day do so with varying degrees of emphasis and on different days of the year`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`InventorsDay`],
					keywords : `inventors day`,
					google   : `Inventors Day`
				}
			},
			{
				dateStr 	 : `February 13th`,
				eventName 	 : `World Radio Day`,
				fromDate	 : new Date('2.13'),
				toDate		 : new Date('2.13'),
				description  : `World Radio Day is an international day celebrated on 13 February each year. The Day was decided by UNESCO on 3 November 2011 during its 36th conference`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldRadioDay`],
					keywords : `radio day`,
					google   : `World Radio Day`
				}
			},
			{
				dateStr 	 : `February 13th`,
				eventName 	 : `Super Bowl LV`,
				fromDate	 : new Date('2.13'),
				toDate		 : new Date('2.13'),
				description  : `Super Bowl LV was the championship game of the National Football League for the 2020 NFL season. The National Football Conference champion Tampa Bay Buccaneers defeated the American Football Conference champion Kansas City Chiefs, 31-9`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`SBLV`, `SuperBowlSunday`, `SuperBowl`],
					keywords : `super bowl`,
					google   : `Super Bowl LV`
				}
			},
			{
				dateStr 	 : `February 14th`,
				eventName 	 : `Valentine's Day`,
				fromDate	 : new Date('2.14'),
				toDate		 : new Date('2.14'),
				description  : `Valentine's Day, also called Saint Valentine's Day or the Feast of Saint Valentine, is celebrated annually on February 14`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`ValentinesDay`],
					keywords : `valentines day`,
					google   : `Valentine's Day`
				}
			},
			{
				dateStr 	 : `February 17th`,
				eventName 	 : `Random Acts of Kindness Day`,
				fromDate	 : new Date('2.17'),
				toDate		 : new Date('2.17'),
				description  : `Random Acts of Kindness Day is a day to celebrate and encourage random acts of kindness. 'It's just a day to celebrate kindness and the whole pay it forward mentality', said Tracy Van Kalsbeek, executive director of the Stratford Perth Community Foundation, in 2016, where the day is celebrated on November 4`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`RandomActsOfKindnessDay`],
					keywords : `kindness day`,
					google   : `Random Acts of Kindness Day`
				}
			},
			{
				dateStr 	 : `February 18th`,
				eventName 	 : `National Battery Day`,
				fromDate	 : new Date('2.18'),
				toDate		 : new Date('2.18'),
				description  : `National Battery Day Is February 18 - A Time To Recognize Lead Batteries' Role In Pandemic Healing And Economic Recovery`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalBatteryDay`],
					keywords : `battery day`,
					google   : `National Battery Day`
				}
			},
			{
				dateStr 	 : `February 20th`,
				eventName 	 : `World Day of Social Justice`,
				fromDate	 : new Date('2.20'),
				toDate		 : new Date('2.20'),
				description  : `World Day of Social Justice is an international day recognizing the need to promote social justice, which includes efforts to tackle issues such as poverty, exclusion, gender inequality, unemployment, human rights, and social protections`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`SocialJusticeDay`],
					keywords : `social justice`,
					google   : `World Day of Social Justice`
				}
			},
			{
				dateStr 	 : `February 20th`,
				eventName 	 : `Love Your Pet Day`,
				fromDate	 : new Date('2.20'),
				toDate		 : new Date('2.20'),
				description  : `Pet lovers everywhere observe National Love Your Pet Day. This holiday focuses on giving extra attention to our pets. The day encourages pampering our pets and focusing on the special relationship pets hold in our lives`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`LoveYourPetDay`],
					keywords : `pet day`,
					google   : `Love Your Pet Day`
				}
			},
			{
				dateStr 	 : `February 21st`,
				eventName 	 : `International Mother Language Day`,
				fromDate	 : new Date('2.21'),
				toDate		 : new Date('2.21'),
				description  : `International Mother Language Day is a worldwide annual observance held on 21 February to promote awareness of linguistic and cultural diversity and to promote multilingualism`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`IMLD`],
					keywords : `mother language day`,
					google   : `International Mother Language Day`
				}
			},
			{
				dateStr 	 : `February 21st`,
				eventName 	 : `Presidents Day`,
				fromDate	 : new Date('2-21'),
				toDate		 : new Date('2-21'),
				description  : `Presidents' Day, officially Washington's Birthday, in the United States, holiday (third Monday in February) popularly recognized as honouring George Washington and Abraham Lincoln. The day is sometimes understood as a celebration of the birthdays and lives of all U.S. presidents`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`PresidentsDay`],
					keywords : `presidents day`,
					google   : `Presidents Day`
				}
			}
		]
	},
	{
		month: {
			number	 : 2,
			name	 : EnumMonth.March
		},
		majorEvent: {
			name	 : `St. Patrick's Day`,
			icon	 : {
				style: 'solid',
				name : `beer-mug-empty`
			}
		},
		events: [
			{
				dateStr 	 : `March 1st`,
				eventName 	 : `Mardi Gras`,
				fromDate	 : new Date('3.1'),
				toDate		 : new Date('3.1'),
				description  : `Mardi Gras, or Fat Tuesday, refers to events of the Carnival celebration, beginning on or after the Christian feasts of the Epiphany and culminating on the day before Ash Wednesday, which is known as Shrove Tuesday`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`MardiGras`],
					keywords : `mardi gras`,
					google   : `Mardi Gras`
				}
			},
			{
				dateStr 	 : `March 2nd`,
				eventName 	 : `National Read Across America Day`,
				fromDate	 : new Date('3.2'),
				toDate		 : new Date('3.2'),
				description  : `A day to celebrate our favorite activity. The day occurs each year on the birthday of beloved children's book author Dr. Seuss, so a perfect way to celebrate is to don a Seussian hat and read one his famous tales, like One Fish Two Fish Red Fish Blue Fish`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`ReadAcrossAmerica`, `DrSeuss`],
					keywords : `read across`,
					google   : `National Read Across America Day`
				}
			},
			{
				dateStr 	 : `March 3rd`,
				eventName 	 : `World Wildlife Day`,
				fromDate	 : new Date('3.3'),
				toDate		 : new Date('3.3'),
				description  : `World Wildlife Day is an opportunity to celebrate the many beautiful and varied forms of wild fauna and flora and to raise awareness of the multitude of benefits that their conservation provides to people`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldWildlifeDay`],
					keywords : `wildlife day`,
					google   : `World Wildlife Day`
				}
			},
			{
				dateStr 	 : `March 4th`,
				eventName 	 : `National Grammar Day`,
				fromDate	 : new Date('3.4'),
				toDate		 : new Date('3.4'),
				description  : `The observance encourages the use of correct grammar in both verbal and written language. According to the Global Language Monitor, the estimated number of words in the English language is 1,025,109`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalGrammarDay`],
					keywords : `grammar day`,
					google   : `National Grammar Day`
				}
			},
			{
				dateStr 	 : `March 4th`,
				eventName 	 : `National Employee Appreciation Day`,
				fromDate	 : new Date('3.4'),
				toDate		 : new Date('3.4'),
				description  : `It is a day for companies to thank their employees for their hard work and effort throughout the year. This day was created for the purpose of strengthening the bond between employer and employee`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`EmployeeAppreciationDay`],
					keywords : `employee appreciation`,
					google   : `National Employee Appreciation Day`
				}
			},
			{
				dateStr 	 : `March 4th`,
				eventName 	 : `National Day of Unplugging`,
				fromDate	 : new Date('3.4'),
				toDate		 : new Date('3.4'),
				description  : `National Day of Unplugging, kicks off a 24 hour period from sundown to sundown, to unplug, unwind, relax and do things other than using today's technology, electronics, and social media`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalDayOfUnplugging`],
					keywords : `unplugging day`,
					google   : `National Day of Unplugging`
				}
			},
			{
				dateStr 	 : `March 6th`,
				eventName 	 : `National Dentist's Day`,
				fromDate	 : new Date('3.6'),
				toDate		 : new Date('3.6'),
				description  : `National Dentist's Day is an opportunity to show appreciation for the dentists and dental specialists who keep our mouths healthy, including general dentists, pediatric dentists, orthodontists, oral surgeons and prosthodontists`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`DentistsDay`],
					keywords : `dentists day`,
					google   : `National Dentist's Day`
				}
			},
			{
				dateStr 	 : `March 7th`,
				eventName 	 : `National Be Heard Day`,
				fromDate	 : new Date(3.7),
				toDate		 : new Date(3.7),
				description  : `National Be Heard Day is an occasion for small businesses owners and aspiring owners to make their voices heard. The day celebrates small businesses and encourages them to stand up for themselves and their ideas and lay claim to their share of the market`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalBeHeardDay`],
					keywords : `be heard day`,
					google   : `National Be Heard Day`
				}
			},
			{
				dateStr 	 : `March 7th`,
				eventName 	 : `National Cereal Day`,
				fromDate	 : new Date('3.7'),
				toDate		 : new Date('3.7'),
				description  : `Strange that the invention of breakfast cereal was founded on the fact that the American diet of the mid 1800's was a poor one packed with protein, booze and caffeine. After all, cereal was considered a remedy – a sort of 19th-century health or wonder food for the ailing masses`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalCerealDay`],
					keywords : `cereal day`,
					google   : `National Cereal Day`
				}
			},
			{
				dateStr 	 : `March 8th`,
				eventName 	 : `International Women's Day`,
				fromDate	 : new Date('3.8'),
				toDate		 : new Date('3.8'),
				description  : `International Women's Day is a global holiday celebrated annually on March 8 to commemorate the cultural, political, and socioeconomic achievements of women`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`BeBoldForChange`],
					keywords : `women day`,
					google   : `International Women's Day`
				}
			},
			{
				dateStr 	 : `March 8th`,
				eventName 	 : `National Proofreading Day`,
				fromDate	 : new Date('3.8'),
				toDate		 : new Date('3.8'),
				description  : `National Proofreading Day, celebrated each year on March 8, is a day to promote error-free writing`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalProofreadingDay`],
					keywords : `proofreading`,
					google   : `National Proofreading Day`
				}
			},
			{
				dateStr 	 : `March 10th`,
				eventName 	 : `National Pack Your Lunch Day`,
				fromDate	 : new Date('3.10'),
				toDate		 : new Date('3.10'),
				description  : `Recapture the magic on March 10 with National Pack Your Lunch Day! From the classic PB&J to the Pinterest-worthy mason jar salad, homemade lunches are both fun and filling`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalPackYourLunchDay`],
					keywords : `pack lunch day`,
					google   : `National Pack Your Lunch Day`
				}
			},
			{
				dateStr 	 : `March 10th`,
				eventName 	 : `National HIV/AIDS Awareness Day`,
				fromDate	 : new Date('3.10'),
				toDate		 : new Date('3.10'),
				description  : `Since 2005, March 10 marks the annual observance of the National Women and Girls HIV/AIDS Awareness Day (NWGHAAD). NWGHAAD's goal is to raise awareness about how women can protect themselves and their partners from HIV`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NWGHAAD`],
					keywords : `hiv awareness day`,
					google   : `National HIV/AIDS Awareness Day`
				}
			},
			{
				dateStr 	 : `March 11th`,
				eventName 	 : `National Worship of Tools Day`,
				fromDate	 : new Date('3.11'),
				toDate		 : new Date('3.11'),
				description  : `Worship of Tools Day is a chance for men to celebrate tools by working with them or buying one. A tool is any physical item that can be used to achieve a goal, especially if the item is not consumed in the process`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorshipOfToolsDay`],
					keywords : `tools day`,
					google   : `National Worship of Tools Day`
				}
			},
			{
				dateStr 	 : `March 11th`,
				eventName 	 : `Popcorn Lover's Day`,
				fromDate	 : new Date('3.11'),
				toDate		 : new Date('3.11'),
				description  : `This day was created on January 6, 2012, by Bob Matthews of Rochester, NY. It is Bob's favorite snack. He and his wife Debbie, enjoy popcorn have it on most Thursdays, all year long`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`PopcornLoversDay`],
					keywords : `popcorn day`,
					google   : `Popcorn Lover's Day`
				}
			},
			{
				dateStr 	 : `March 12th`,
				eventName 	 : `National Girl Scout Day`,
				fromDate	 : new Date('3.12'),
				toDate		 : new Date('3.12'),
				description  : `Girl Scouts' birthday, March 12, commemorates the day in 1912 when Juliette Gordon Low officially registered the organization's first 18 members in Savannah, Georgia`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`GirlScoutDay`],
					keywords : `girl scout`,
					google   : `National Girl Scout Day`
				}
			},
			{
				dateStr 	 : `March 14th`,
				eventName 	 : `Potato Chip Day`,
				fromDate	 : new Date('3.14'),
				toDate		 : new Date('3.14'),
				description  : `America's most popular snack, potato chips are celebrated across the globe on National Potato Chip day`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalPotatoChipDay`],
					keywords : `potato chip day`,
					google   : `Potato Chip Day`
				}
			},
			{
				dateStr 	 : `March 14th`,
				eventName 	 : `Pi Day`,
				fromDate	 : new Date('3.14'),
				toDate		 : new Date('3.14'),
				description  : `Pi Day is an annual celebration of the mathematical constant π. Pi Day is observed on March 14 since 3, 1, and 4 are the first three significant digits of π. It was founded in 1988 by Larry Shaw, an employee of the Exploratorium. Celebrations often involve eating pie or holding pi recitation competitions`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`PiDay`],
					keywords : `pi day`,
					google   : `Pi Day`
				}
			},
			{
				dateStr 	 : `March 13th`,
				eventName 	 : `Daylight Savings`,
				fromDate	 : new Date('3.13'),
				toDate		 : new Date('3.13'),
				description  : `Daylight saving time, also known as daylight savings time or daylight time, and summer time, is the practice of advancing clocks during warmer months so that darkness falls at a later clock time`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`DaylightSavings`],
					keywords : `daylight savings`,
					google   : `Daylight Savings`
				}
			},
			{
				dateStr 	 : `March 15th`,
				eventName 	 : `National Napping Day`,
				fromDate	 : new Date('3.15'),
				toDate		 : new Date('3.15'),
				description  : `In 1999, the late William Anthony, a psychologist and Boston University professor, and his wife, Camille, instituted National Napping Day. Their intent was to overcome American cultural prejudice against napping and to raise awareness about the health benefits of catching up on quality sleep`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalNappingDay`],
					keywords : `napping day`,
					google   : `National Napping Day`
				}
			},
			{
				dateStr 	 : `March 15th`,
				eventName 	 : `World Consumer Rights Day`,
				fromDate	 : new Date('3.15'),
				toDate		 : new Date('3.15'),
				description  : `World Consumers Rights Day - Consumers International. The consumer movement marks 15th March with World Consumer Rights Day every year, as a means of raising global awareness about consumer rights and needs`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldConsumerRightsDay`],
					keywords : `consumer rights`,
					google   : `World Consumer Rights Day`
				}
			},
			{
				dateStr 	 : `March 16th`,
				eventName 	 : `National Freedom of Information Day`,
				fromDate	 : new Date('3.16'),
				toDate		 : new Date('3.16'),
				description  : `Freedom of Information Day is an annual celebration observed on March 16. Information is wealth, and as a citizen of a nation, anyone has the right to know. By freedom of information means that the general public has got the right to the data held by the national governments`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`FreedomOfInformationDay`],
					keywords : `freedom information`,
					google   : `National Freedom of Information Day`
				}
			},
			{
				dateStr 	 : `March 17th`,
				eventName 	 : `St. Patrick's Day`,
				fromDate	 : new Date('3.17'),
				toDate		 : new Date('3.17'),
				description  : `Saint Patrick's Day, or the Feast of Saint Patrick, is a cultural and religious celebration held on 17 March, the traditional death date of Saint Patrick, the foremost patron saint of Ireland`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`StPatricksDay`],
					keywords : `st patricks day`,
					google   : `St. Patrick's Day`
				}
			},
			{
				dateStr 	 : `March 18th`,
				eventName 	 : `Awkward Moments Day`,
				fromDate	 : new Date('3.18'),
				toDate		 : new Date('3.18'),
				description  : `The day is to celebrate the awkward and embarrassing moments that are part of our life which happens from time to time. It is fascinating to see that Awkward Moments Day is the day after Saint Patricks Day (Day associated with alcohol and partying)`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalAwkwardMomentsDay`],
					keywords : `awkward moment`,
					google   : `Awkward Moments Day`
				}
			},
			{
				dateStr 	 : `March 19th`,
				eventName 	 : `National Let's Laugh Day`,
				fromDate	 : new Date('3.19'),
				toDate		 : new Date('3.19'),
				description  : `Each year, National Let's Laugh Day on March 19th reminds us to add a little humor to our day. It's never good to be serious all the time and letting the laughter bubble up from time to time is good for all of us`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalLetsLaughDay`],
					keywords : `laugh day`,
					google   : `National Let's Laugh Day`
				}
			},
			{
				dateStr 	 : `March 19th`,
				eventName 	 : `World Sleep Day`,
				fromDate	 : new Date('3,19'),
				toDate		 : new Date('3,19'),
				description  : `Focusing on the importance of sleep every year an annual event World Sleep Day is organized by the World Sleep Day Committee of World Sleep Society which aims to lessen the burden of sleep problems on society through better prevention and management of sleep disorders`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldSleepDay`],
					keywords : `sleep day`,
					google   : `World Sleep Day`
				}
			},
			{
				dateStr 	 : `March 19th`,
				eventName 	 : `Red Nose Day`,
				fromDate	 : new Date('3.19'),
				toDate		 : new Date('3.19'),
				description  : `Red Nose Day is a campaign with the mission to end child poverty by funding programs that keep children safe, healthy, educated and empowered. Through the power of entertainment, we bring people together to laugh and have fun, all while raising life-changing cash for the children that need it the most. Since our debut in 2015, we have raised over $270 million and have positively impacted over 25 million children in America, and around the world`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`RedNoseDay`],
					keywords : `red nose day`,
					google   : `Red Nose Day`
				}
			},
			{
				dateStr 	 : `March 20th`,
				eventName 	 : `International Day of Happiness`,
				fromDate	 : new Date('3.20'),
				toDate		 : new Date('3.20'),
				description  : `It was established by the United Nations General Assembly on 28 June 2012. The International Day of Happiness aims to make people around the world realize the importance of happiness within their lives`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`InternationalDayOfHappiness`],
					keywords : `happiness day`,
					google   : `International Day of Happiness`
				}
			},
			{
				dateStr 	 : `March 20th`,
				eventName 	 : `World Storytelling Day`,
				fromDate	 : new Date('3.20'),
				toDate		 : new Date('3.20'),
				description  : `World Storytelling Day is a global celebration of the art of oral storytelling. It is celebrated every year on the March equinox, on March 20. On World Storytelling Day, as many people as possible tell and listen to stories in as many languages and at as many places as possible, during the same day and night`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldStorytellingDay`],
					keywords : `storytelling`,
					google   : `World Storytelling Day`
				}
			},
			{
				dateStr 	 : `March 20th`,
				eventName 	 : `First Day of Spring`,
				fromDate	 : new Date('3.20'),
				toDate		 : new Date('3.20'),
				description  : `The spring equinox - also known as vernal equinox - marks the date when light and dark last the same amount of time - with the sun bound to stay up in the sky more and more until the June solstice. Add to this that British Summer Time is on our doorstep too, and sunshine is slowly but surely arriving on our shores`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`FirstDayOfSpring`],
					keywords : `first day of spring`,
					google   : `First Day of Spring`
				}
			},
			{
				dateStr 	 : `March 21st`,
				eventName 	 : `International Day for the Elimination of Racial Discrimination`,
				fromDate	 : new Date('3.21'),
				toDate		 : new Date('3.21'),
				description  : `The International Day for the Elimination of Racial Discrimination is observed annually on 21 March. On that day, in 1960, police opened fire and killed 69 people at a peaceful demonstration in Sharpeville, South Africa, against the apartheid pass laws`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`RacialDiscriminationDay`],
					keywords : `elimination racial discrimination`,
					google   : `International Day for the Elimination of Racial Discrimination`
				}
			},
			{
				dateStr 	 : `March 21st`,
				eventName 	 : `World Poetry Day`,
				fromDate	 : new Date('3.21'),
				toDate		 : new Date('3.21'),
				description  : `with the aim of supporting linguistic diversity through poetic expression and increasing the opportunity for endangered languages to be heard, this day is celebrated and declared by UNESCO in 199`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldPoetryDay`],
					keywords : `poetry day`,
					google   : `World Poetry Day`
				}
			},
			{
				dateStr 	 : `March 22nd`,
				eventName 	 : `World Water Day`,
				fromDate	 : new Date('3.22'),
				toDate		 : new Date('3.22'),
				description  : `World Water Day celebrates water and raises awareness of the 2.2 billion people living without access to safe water. A core focus of World Water Day is to support the achievement of Sustainable Development Goal 6: water and sanitation for all by 2030.2`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldWaterDay`],
					keywords : `water day`,
					google   : `World Water Day`
				}
			},
			{
				dateStr 	 : `March 23rd`,
				eventName 	 : `National Puppy Day`,
				fromDate	 : new Date('3.23'),
				toDate		 : new Date('3.23'),
				description  : `The idea is to focus attention on puppies in need of adoption, and on the abuses found in puppy mills, but also to celebrate these furry little companions`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalPuppyDay`],
					keywords : `puppy day`,
					google   : `National Puppy Day`
				}
			},
			{
				dateStr 	 : `March 23rd`,
				eventName 	 : `American Diabetes Association Alert Day`,
				fromDate	 : new Date('3.23'),
				toDate		 : new Date('3.23'),
				description  : `Diabetes Alert Day is a one-day “wake-up call” that focuses on the seriousness of diabetes and the importance of understanding your risk`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`AmericanDiabetesAssociationAlertDay`],
					keywords : `diabetes day`,
					google   : `American Diabetes Association Alert Day`
				}
			},
			{
				dateStr 	 : `March 25th`,
				eventName 	 : `Tolkien Reading Day`,
				fromDate	 : new Date('3.25'),
				toDate		 : new Date('3.25'),
				description  : `Tolkien Reading Day is held on the 25th of March each year. It has been organised by the Tolkien Society since 2003 to encourage fans to celebrate and promote the life and works of J.R.R. Tolkien by reading favorite passages`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`TolkienReadingDay`],
					keywords : `tolkien reading`,
					google   : `Tolkien Reading Day`
				}
			},
			{
				dateStr 	 : `March 26th`,
				eventName 	 : `National Spinach Day`,
				fromDate	 : new Date('3.26'),
				toDate		 : new Date('3.26'),
				description  : `National Spinach Day reminds us of the health benefits packed into this leafy green vegetable. Not only are there so many delicious ways that you can enjoy spinach, but it is also incredibly good for you! An annual plant, spinach grows natively in central and southwestern Asia`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalSpinachDay`],
					keywords : `spinach day`,
					google   : `National Spinach Day`
				}
			},
			{
				dateStr 	 : `March 26th`,
				eventName 	 : `Purple Day`,
				fromDate	 : new Date('3.26'),
				toDate		 : new Date('3.26'),
				description  : `Purple Day is a global grassroots event that was formed with the intention to increase worldwide awareness of epilepsy, and to dispel common myths and fears of this neurological disorder`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`PurpleDay`],
					keywords : `purple day`,
					google   : `Purple Day`
				}
			},
			{
				dateStr 	 : `March 27th`,
				eventName 	 : `Earth Hour Day`,
				fromDate	 : new Date('3.27'),
				toDate		 : new Date('3.27'),
				description  : `The annual tradition of shutting down electric lights for one hour was started by the World Wide Fund for Nature (WWF). The aim was to encourage individuals, communities, and businesses to turn off all non-essential lights for an entire hour symbolising their commitment to the planet Earth`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`EarthHour`],
					keywords : `earth hour`,
					google   : `Earth Hour Day`
				}
			},
			{
				dateStr 	 : `March 30th`,
				eventName 	 : `Doctor's Day`,
				fromDate	 : new Date('3.30'),
				toDate		 : new Date('3.30'),
				description  : `National Doctors' Day is a day on which the service of physicians to the nation is recognized annually. The idea came from Eudora Brown Almond, wife of Dr. Charles B. Almond, and the date chosen was the anniversary of the first use of general anesthesia in surgery`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalDoctorsDay`],
					keywords : `doctors day`,
					google   : `Doctor's Day`
				}
			},
			{
				dateStr 	 : `March 30th`,
				eventName 	 : `National Take a Walk in the Park Day`,
				fromDate	 : new Date('3.30'),
				toDate		 : new Date('3.30'),
				description  : `This day was founded to help people reconnect with the wilder spaces within our civilized world. Thousands of people all over the country walk in local parks, exploring the wildlife and beauty of the natural world around them`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalWalkInTheParkDay`],
					keywords : `take a walk`,
					google   : `National Take a Walk in the Park Day`
				}
			},
			{
				dateStr 	 : `March 31st`,
				eventName 	 : `World Backup Day`,
				fromDate	 : new Date('3.31'),
				toDate		 : new Date('3.31'),
				description  : `World Backup Day on March 31st reminds us to protect our precious digital documents as we've become more reliant on technology. There's always that one photo, video or memory that you took the time to save, yet for some reason, it's not yours anymore`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldBackupDay`],
					keywords : `backup day`,
					google   : `World Backup Day`
				}
			},
			{
				dateStr 	 : `March 31st`,
				eventName 	 : `Transgender Day of Visibility`,
				fromDate	 : new Date('3.31'),
				toDate		 : new Date('3.31'),
				description  : `International Transgender Day of Visibility (also called TDOV, Transgender Day of Visibility) is an annual event dedicated to celebrating transgender people and raising awareness of discrimination faced by transgender people worldwide, as well as a celebration of their contributions to society`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`TDOV`],
					keywords : `transgender day`,
					google   : `Transgender Day of Visibility`
				}
			},
			{
				dateStr 	 : `March 31st`,
				eventName 	 : `Equal Pay Day`,
				fromDate	 : new Date('3.31'),
				toDate		 : new Date('3.31'),
				description  : `Equal Pay Day is the symbolic day dedicated to raising awareness of the gender pay gap. In the United States, this date symbolizes how far into the year the average women must work in order to have earned what the average man had earned the entire previous year, regardless of experience or job type`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`EqualPayDay`],
					keywords : `equal pay`,
					google   : `Equal Pay Day`
				}
			}
		]
	},
	{
		month: {
			number	 : 3,
			name	 : EnumMonth.April
		},
		majorEvent: {
			name	 : `Stress Awareness Month`,
			icon	 : {
				style: 'solid',
				name : `brain`
			}
		},
		events: [
			{
				dateStr 	 : `April 1st - 30th`,
				eventName 	 : `National Stress Awareness Month`,
				fromDate	 : new Date('4.1'),
				toDate		 : new Date('4.30'),
				description  : `April is National National Stress Awareness Month, and while stress is unavoidable for the vast majority of Americans, there are many ways to help prevent and manage it`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`NationalStressAwareness`],
					keywords : `stress awareness`,
					google   : `National Stress Awareness Month`
				}
			},
			{
				dateStr 	 : `April 1st`,
				eventName 	 : `April Fools Day`,
				fromDate	 : new Date('4.1'),
				toDate		 : new Date('4.1'),
				description  : `April Fool's Day is an annual custom on 1st April consisting of practical jokes and hoaxes. Jokesters often expose their actions by shouting 'April Fools!' at the recipient. Mass media can be involved in these pranks, which may be revealed as such the following day`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`AprilFools`],
					keywords : `april fools day`,
					google   : `April Fools Day`
				}
			},
			{
				dateStr 	 : `April 2nd`,
				eventName 	 : `World Autism Awareness Day`,
				fromDate	 : new Date('4.2'),
				toDate		 : new Date('4.2'),
				description  : `World Autism Awareness Day is an internationally recognized day on April 2 every year, encouraging Member States of the United Nations to take measures to raise awareness about people with Autism Spectrum Disorder throughout the world. It was designated by the United Nations General Assembly resolution`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`WAAD`],
					keywords : `autism day`,
					google   : `World Autism Awareness Day`
				}
			},
			{
				dateStr 	 : `April 3rd`,
				eventName 	 : `Find a Rainbow Day`,
				fromDate	 : new Date('4.3'),
				toDate		 : new Date('4.3'),
				description  : `Brings out the awareness of the colors and above all the world is full of beauty and colors. 'That is the idea behind a day devoted to rainbows, because you can't help smiling when you see the bright, cheery bands of color.`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`FindARainbowDay`],
					keywords : `rainbow day`,
					google   : `Find a Rainbow Day`
				}
			},
			{
				dateStr 	 : `April 4th`,
				eventName 	 : `Hug a Newsperson Day`,
				fromDate	 : new Date('4.4'),
				toDate		 : new Date('4.4'),
				description  : `National Hug A Newsperson Day (formerly National Hug a Newsman Day) on April 4th encourages appreciation for the people reporting the news. The Merriam-Webster dictionary tells us that the word “newsman” dates back to 1596. They have been working hard for many years to bring us the news from around the world`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`HugANewsperson`],
					keywords : `newsperson day`,
					google   : `Hug a Newsperson Day`
				}
			},
			{
				dateStr 	 : `April 5th`,
				eventName 	 : `World Health Day`,
				fromDate	 : new Date('4.5'),
				toDate		 : new Date('4.5'),
				description  : `World Health Day is a global health awareness day celebrated every year on 7 April, under the sponsorship of the World Health Organization, as well as other related organizations. In 1948, the WHO held the First World Health Assembly`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`LetsTalk`],
					keywords : `health day`,
					google   : `World Health Day`
				}
			},
			{
				dateStr 	 : `April 6th`,
				eventName 	 : `National Walking Day`,
				fromDate	 : new Date('4.6'),
				toDate		 : new Date('4.6'),
				description  : `National Walking Day significance is to encourage more people to walk as it not only benefits one's health but also the Earth`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalWalkingDay`],
					keywords : `walking day`,
					google   : `National Walking Day`
				}
			},
			{
				dateStr 	 : `April 10th`,
				eventName 	 : `National Siblings Day`,
				fromDate	 : new Date('4.10'),
				toDate		 : new Date('4.10'),
				description  : `The US holiday was conceived by Claudia Evart to honor the memory of her brother and sister, who died at early ages. The Siblings Day Foundation was incorporated in 1997 and achieved non-profit status in 1999`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalSiblingsDay`],
					keywords : `siblings day`,
					google   : `National Siblings Day`
				}
			},
			{
				dateStr 	 : `April 10th`,
				eventName 	 : `Encourage a Young Writer Day`,
				fromDate	 : new Date('4.10'),
				toDate		 : new Date('4.10'),
				description  : `On this day budding authors across the United States are encouraged to write a story, poem, or any form of writing`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`EncourageAYoungWriterDay`],
					keywords : `young writer day`,
					google   : `Encourage a Young Writer Day`
				}
			},
			{
				dateStr 	 : `April 11th`,
				eventName 	 : `National Pet Day`,
				fromDate	 : new Date('4.11'),
				toDate		 : new Date('4.11'),
				description  : `On this day, people are encouraged to love their pets, spoil them, adopt pets, and volunteer at the local animal shelter. National Pet Day celebrates the unconditional love that animals give to people in their daily lives. It also encourages people to take the time to spend time with their beloved animals`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalPetDay`],
					keywords : `pet day`,
					google   : `National Pet Day`
				}
			},
			{
				dateStr 	 : `April 12th`,
				eventName 	 : `International Day of Human Space Flight`,
				fromDate	 : new Date('4.12'),
				toDate		 : new Date('4.12'),
				description  : `The International Day of Human Space Flight is the annual celebration, held on 12 April, of the anniversary of the first human space flight by Yuri Gagarin. It was proclaimed at the 65th session of the United Nations General Assembly on 7 April 2011, a few days before the 50th anniversary of the flight`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`InternationalDayOfHumanSpaceFlight`],
					keywords : `human space flight`,
					google   : `International Day of Human Space Flight`
				}
			},
			{
				dateStr 	 : `April 15th`,
				eventName 	 : `National Tax Day`,
				fromDate	 : new Date('4.15'),
				toDate		 : new Date('4.15'),
				description  : `Tax Day is the day on which individual income tax returns are due to be submitted to the federal government. Since 1955, Tax Day has typically fallen on or just after April 15. Tax Day was first introduced in 1913, when the Sixteenth Amendment was ratified`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`TaxDay`],
					keywords : `tax day`,
					google   : `National Tax Day`
				}
			},
			{
				dateStr 	 : `April 15th`,
				eventName 	 : `National High-Five Day`,
				fromDate	 : new Date('4.15'),
				toDate		 : new Date('4.15'),
				description  : `The high five is a hand gesture that occurs when two people simultaneously raise one hand each, about head-high, and push, slide, or slap the flat of their palm against the flat palm of the other person. The gesture is often preceded verbally by a phrase like “Gimme five!” or “High five!`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NH5D`],
					keywords : `high five day`,
					google   : `National High-Five Day`
				}
			},
			{
				dateStr 	 : `April 16th`,
				eventName 	 : `National Stress Awareness Day`,
				fromDate	 : new Date('4.16'),
				toDate		 : new Date('4.16'),
				description  : `while stress is unavoidable for the vast majority of Americans, there are many ways to help prevent and manage it. Take a look at these seven tips for preventing and managing stress in your life`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`StressAwarenessDay`],
					keywords : `stress awareness day`,
					google   : `National Stress Awareness Day`
				}
			},
			{
				dateStr 	 : `April 16th`,
				eventName 	 : `National Wear Your Pajamas to Work Day`,
				fromDate	 : new Date('4.16'),
				toDate		 : new Date('4.16'),
				description  : `National Wear Your Pajamas To Work Day allows us a reprieve after meeting a late-night deadline shuffling receipts, and adding columns to file our taxes`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`PJDay`],
					keywords : `pajamas work day`,
					google   : `National Wear Your Pajamas to Work Day`
				}
			},
			{
				dateStr 	 : `April 17th`,
				eventName 	 : `Haiku Poetry Day`,
				fromDate	 : new Date('4.17'),
				toDate		 : new Date('4.17'),
				description  : `National Haiku Poetry Day encourages all to try their hand in creativity. Haiku poetry is a form of Japanese poetry that is non-rhyming and usually consists of 3 lines with a syllable pattern of 5-7-5`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`HaikuPoetryDay`],
					keywords : `haiku poetry`,
					google   : `Haiku Poetry Day`
				}
			},
			{
				dateStr 	 : `April 18th`,
				eventName 	 : `National Columnists Day`,
				fromDate	 : new Date('4.18'),
				toDate		 : new Date('4.18'),
				description  : `National Columnists' Day on April 18th honors all newspaper columnists and their contributions to the truth in black and white. Columnists have the ability to inspire a plethora of emotions that often result in action`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalColumnistDay`],
					keywords : `columnists day`,
					google   : 'National Columnists Day'
				}
			},
			{
				dateStr 	 : `April 20th`,
				eventName 	 : `National Look-Alike Day`,
				fromDate	 : new Date('4.20'),
				toDate		 : new Date('4.20'),
				description  : `National Look Alike Day celebrates those who look a lot like another person. This day was created as a fun day to look like another person`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalLookAlikeDay`],
					keywords : `look alike day`,
					google   : `National Look-Alike Day`
				}
			},
			{
				dateStr 	 : `April 21st`,
				eventName 	 : `National Administrative Professionals Day`,
				fromDate	 : new Date('4.21'),
				toDate		 : new Date('4.21'),
				description  : `The day recognizes the work of secretaries, administrative assistants, executive assistants, personal assistants, receptionists, client services representatives, and other administrative support professionals. Typically, administrative professionals are given cards, flowers, chocolates, and lunches`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`AdministrativeProfessionalsDay`],
					keywords : `administrative day`,
					google   : `National Administrative Professionals Day`
				}
			},
			{
				dateStr 	 : `April 21st`,
				eventName 	 : `Get to Know Your Customers Day`,
				fromDate	 : new Date('4.21'),
				toDate		 : new Date('4.21'),
				description  : `While the origin of Get to Know Your Customers Day is unknown, the significance of its purpose is fully understood. Businesses thrive on the repeated patronage of their customers. Get to Know Your Customers Day is the quarterly reminder that prompts companies to understand the needs and opinions of their customer base`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`GetToKnowYourCustomersDay`],
					keywords : `customers day`,
					google   : `Get to Know Your Customers Day`
				}
			},
			{
				dateStr 	 : `April 22nd`,
				eventName 	 : `Earth Day`,
				fromDate	 : new Date('4.22'),
				toDate		 : new Date('4.22'),
				description  : `Earth Day is an annual event on April 22 to demonstrate support for environmental protection. First held on April 22, 1970, it now includes a wide range of events coordinated globally by EarthDay.org including 1 billion people in more than 193 countries`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`EarthDay`],
					keywords : `earth day`,
					google   : `Earth Day`
				}
			},
			{
				dateStr 	 : `April 23rd`,
				eventName 	 : `National Take Our Daughters and Sons to Work Day`,
				fromDate	 : new Date('4.23'),
				toDate		 : new Date('4.23'),
				description  : `Take Our Daughters And Sons To Work Day, also termed Take Your Child to Work Day, is a national day that gives children in the United States a glimpse into the working world`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`CountOnMe`],
					keywords : `child to work day`,
					google   : `National Take Our Daughters and Sons to Work Day`
				}
			},
			{
				dateStr 	 : `April 23rd`,
				eventName 	 : `National Picnic Day`,
				fromDate	 : new Date('4.23'),
				toDate		 : new Date('4.23'),
				description  : `National Picnic Day encourages everyone to pack up their lunch and take it outdoors. There are a variety of ways to take part in a picnic`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalPicnicDay`],
					keywords : `picnic day`,
					google   : `National Picnic Day`
				}
			},
			{
				dateStr 	 : `April 23rd`,
				eventName 	 : `World Book Day`,
				fromDate	 : new Date('4.23'),
				toDate		 : new Date('4.23'),
				description  : `World Book Day, also known as World Book and Copyright Day or International Day of the Book, is an annual event organized by the United Nations Educational, Scientific and Cultural Organization to promote reading, publishing, and copyright`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`WorldBookDay`],
					keywords : `book day`,
					google   : `World Book Day`
				}
			},
			{
				dateStr 	 : `April 23rd`,
				eventName 	 : `Arbor Day`,
				fromDate	 : new Date('4.23'),
				toDate		 : new Date('4.23'),
				description  : `Arbor Day is a secular day of observance in which individuals and groups are encouraged to plant trees. Today, many countries observe such a holiday. Though usually observed in the spring, the date varies, depending on climate and suitable planting season`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`ArborDay`],
					keywords : `arbor day`,
					google   : `Arbor Day`
				}
			},
			{
				dateStr 	 : `April 25th`,
				eventName 	 : `National Telephone Day`,
				fromDate	 : new Date('4.25'),
				toDate		 : new Date('4.25'),
				description  : `On April 25th, we observe National Telephone Day. Around the world, there are 9.82 billion mobile phones. And while some predicted the landline to be obsolete by 2020, there are still about 931 million landlines around the world`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalTelephoneDay`],
					keywords : `telephone day`,
					google   : `National Telephone Day`
				}
			},
			{
				dateStr 	 : `April 25th`,
				eventName 	 : `World Malaria Day`,
				fromDate	 : new Date('4.25'),
				toDate		 : new Date('4.25'),
				description  : `World Malaria Day is an international observance commemorated every year on 25 April and recognizes global efforts to control malaria. Globally, 3.3 billion people in 106 countries are at risk of malaria. In 2012, malaria caused an estimated 627,000 deaths, mostly among African children`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`EndMalariaForGood`],
					keywords : `malaria day`,
					google   : `World Malaria Day`
				}
			},
			{
				dateStr 	 : `April 28th`,
				eventName 	 : `Denim Day`,
				fromDate	 : new Date('4.28'),
				toDate		 : new Date('4.28'),
				description  : `Denim Day takes place on the last Wednesday of April, which is Sexual Assault Awareness Month. This day of action and awareness is an event in which people are encouraged to wear denim to combat victim blaming and educate others about sexual violence`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`DenimDay`],
					keywords : `denim day`,
					google   : `Denim Day`
				}
			},
			{
				dateStr 	 : `April 29th`,
				eventName 	 : `International Dance Day`,
				fromDate	 : new Date('4.29'),
				toDate		 : new Date('4.29'),
				description  : `International Dance Day is a global celebration of dance, created by the Dance Committee of the International Theatre Institute, the main partner for the performing arts of UNESCO. The event takes place every year on 29 April, which is the anniversary of the birth of Jean-Georges Noverre, the creator of modern ballet`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`InternationalDanceDay`],
					keywords : `dance day`,
					google   : `International Dance Day`
				}
			},
			{
				dateStr 	 : `April 30th`,
				eventName 	 : `National Honesty Day`,
				fromDate	 : new Date('4.30'),
				toDate		 : new Date('4.30'),
				description  : `Honesty Day is celebrated on April 30 in the United States to encourage honesty and straightforward communication in politics, relationships, consumer relations and historical education. It was invented by M. Hirsh Goldberg, who chose the last day of April for two reasons`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalHonestyDay`],
					keywords : `honesty day`,
					google   : `National Honesty Day`
				}
			},
			{
				dateStr 	 : `April 30th`,
				eventName 	 : `National Adopt a Shelter Pet Day`,
				fromDate	 : new Date('4.30'),
				toDate		 : new Date('4.30'),
				description  : `National Adopt A Shelter Pet Day is celebrated across the nation on April 30 and we are getting ready to observe the day by going to pet shelters, adopting as many pets as possible, spreading the word among our friends and colleagues, and taking to social media to spread the message to everyone`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`AdoptAShelterPetDay`],
					keywords : `adopt pet day`,
					google   : `National Adopt a Shelter Pet Day`
				}
			},
			{
				dateStr 	 : `April 30th`,
				eventName 	 : `International Jazz Day`,
				fromDate	 : new Date('4.30'),
				toDate		 : new Date('4.30'),
				description  : `International Jazz Day is an International Day declared by the United Nations Educational, Scientific and Cultural Organization in 2011 'to highlight jazz and its diplomatic role of uniting people in all corners of the globe.`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`JazzDay`],
					keywords : `jazz day`,
					google   : `International Jazz Day`
				}
			}
		]
	},
	{
		month: {
			number	 : 4,
			name	 : EnumMonth.May
		},
		majorEvent: {
			name	 : `Mother's Day`,
			icon	 : {
				style: 'solid',
				name : `person-dress`
			}
		},
		events: [
			{
				dateStr 	 : `May 1st`,
				eventName 	 : `May Day`,
				fromDate	 : new Date('5.1'),
				toDate		 : new Date('5.1'),
				description  : `May Day is an ancient festival marking the first day of summer, and a current traditional spring holiday in many European cultures. Dances, singing, and cake are usually part of the festivities`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`MayDay`],
					keywords : `may day`,
					google   : `May Day`
				}
			},
			{
				dateStr 	 : `May 1st`,
				eventName 	 : `International Workers Day`,
				fromDate	 : new Date('5.1'),
				toDate		 : new Date('5.1'),
				description  : `International Workers' Day, also known as Labour Day in most countries and often referred to as May Day, is a celebration of labourers and the working classes that is promoted by the international labour movement and occurs every year on May Day`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`IntWorkersDay`],
					keywords : `workers day`,
					google   : `International Workers Day`
				}
			},
			{
				dateStr 	 : `May 3rd`,
				eventName 	 : `World Press Freedom Day`,
				fromDate	 : new Date('5.3'),
				toDate		 : new Date('5.3'),
				description  : `World Press Freedom Day was proclaimed by the UN General Assembly in December 1993, following the recommendation of UNESCO's General Conference. May 3 acts as a reminder to governments of the need to respect their commitment to press freedom`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`PressFreedom`],
					keywords : `press freedom`,
					google   : `World Press Freedom Day`
				}
			},
			{
				dateStr 	 : `May 4th`,
				eventName 	 : `Star Wars Day`,
				fromDate	 : new Date('5.4'),
				toDate		 : new Date('5.4'),
				description  : `Star Wars Day is an informal commemorative day observed annually on May 4 to celebrate The Walt Disney Company's Star Wars media franchise created by founder and former chairman and CEO of Lucasfilm, George Lucas`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`StarWarsDay`, `MayThe4thBeWithYou`],
					keywords : `star wars day`,
					google   : `Star Wars Day`
				}
			},
			{
				dateStr 	 : `May 4th`,
				eventName 	 : `International Firefighters Day`,
				fromDate	 : new Date('5.4'),
				toDate		 : new Date('5.4'),
				description  : `International Firefighters' Day is observed on May 4. It was instituted after a proposal was emailed out around the world on January 4, 1999 due to the deaths of five firefighters in tragic circumstances in a bushfire in Australia`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`InternationalFirefightersDay`],
					keywords : `firefighters day`,
					google   : `International Firefighters Day`
				}
			},
			{
				dateStr 	 : `May 4th`,
				eventName 	 : `World Asthma Day`,
				fromDate	 : new Date('5.4'),
				toDate		 : new Date('5.4'),
				description  : `World Asthma Day is an annual event organized by the Global Initiative for Asthma to improve asthma awareness and care around the world. World Asthma Day takes place on May 5th. The theme of 2021's event was "Uncovering Asthma Misconceptions". The inaugural World Asthma Day was held in 1998`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldAsthmaDay`],
					keywords : `asthma day`,
					google   : `World Asthma Day`
				}
			},
			{
				dateStr 	 : `May 4th`,
				eventName 	 : `Thank a Teacher Day`,
				fromDate	 : new Date('5.4'),
				toDate		 : new Date('5.4'),
				description  : `National Teacher Day began in 1953 when former First Lady Eleanor Roosevelt proposed that Congress set aside a day to acknowledge the work of educators`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`ThankATeacher`],
					keywords : `teacher day`,
					google   : `Thank a Teacher Day`
				}
			},
			{
				dateStr 	 : `May 5th`,
				eventName 	 : `Cinco de Mayo`,
				fromDate	 : new Date('5.5'),
				toDate		 : new Date('5.5'),
				description  : `Cinco de Mayo is an annual celebration held on May 5, which commemorates the anniversary of Mexico's victory over the French Empire at the Battle of Puebla in 1862`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`CincoDeMayo`],
					keywords : `cinco de mayo`,
					google   : `Cinco de Mayo`
				}
			},
			{
				dateStr 	 : `May 6th`,
				eventName 	 : `National Nurses Day`,
				fromDate	 : new Date('5.6'),
				toDate		 : new Date('5.6'),
				description  : `The anniversary of Florence Nightingale's birth) of each year, to mark the contributions that nurses make to society`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NursesDay`],
					keywords : `nurses day`,
					google   : `National Nurses Day`
				}
			},
			{
				dateStr 	 : `May 7th`,
				eventName 	 : `World Password Day`,
				fromDate	 : new Date('5.7'),
				toDate		 : new Date('5.7'),
				description  : `A day dedicated to promoting safer password practices. Below, security executives share their insight and tips on how to create and promote safer password practices in the enterprise and among employees`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldPasswordDay`],
					keywords : `password day`,
					google   : `World Password Day`
				}
			},
			{
				dateStr 	 : `May 7th`,
				eventName 	 : `Space Day`,
				fromDate	 : new Date('5.7'),
				toDate		 : new Date('5.7'),
				description  : `National Space Day dedicates to the extraordinary achievements, benefits, and opportunities in the exploration and use of space. The goal of the observance is to promote math, science, technology, and engineering education in young people, The hope is to inspire them to pursue a career in science, especially a career in space-related jobs`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`SpaceDay`],
					keywords : `space day`,
					google   : `Space Day`
				}
			},
			{
				dateStr 	 : `May 9th`,
				eventName 	 : `Europe Day`,
				fromDate	 : new Date('5.9'),
				toDate		 : new Date('5.9'),
				description  : `Europe Day is a day celebrating "peace and unity in Europe" celebrated on 5 May by the Council of Europe and on 9 May by the European Union. The first recognition of Europe Day was by the Council of Europe, introduced in 1964`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`EuropeDay`],
					keywords : `europe day`,
					google   : `Europe Day`
				}
			},
			{
				dateStr 	 : `May 9th`,
				eventName 	 : `Mother's Day`,
				fromDate	 : new Date('5.9'),
				toDate		 : new Date('5.9'),
				description  : `Mother's Day is a celebration honoring the mother of the family or individual, as well as motherhood, maternal bonds, and the influence of mothers in society. It is celebrated on different days in many parts of the world, most commonly in the months of March or May`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`MothersDay`],
					keywords : `mothers day`,
					google   : `Mother's Day`
				}
			},
			{
				dateStr 	 : `May 12th`,
				eventName 	 : `National Limerick Day`,
				fromDate	 : new Date('5.12'),
				toDate		 : new Date('5.12'),
				description  : `National Limerick Day is set on 12th May to mark the birthday of Edward Lear, the English writer known for his works of nonsensical prose and poetry. It was Edward Lear who was to popularise the Limerick in his A Book of Nonsense, published 1846`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalLimerickDay`],
					keywords : `limerick day`,
					google   : `National Limerick Day`
				}
			},
			{
				dateStr 	 : `May 12th`,
				eventName 	 : `National Receptionist Day`,
				fromDate	 : new Date('5.12'),
				toDate		 : new Date('5.12'),
				description  : `A day to recognize and appreciate all the things that you do! The purpose of Receptionists Day are two-fold. First, of all it gives recognition to receptionists. After all, they are the first person your customers see when they walk through the door of your company`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalReceptionistDay`],
					keywords : `receptionist day`,
					google   : `National Receptionist Day`
				}
			},
			{
				dateStr 	 : `May 15th`,
				eventName 	 : `International Day of Families`,
				fromDate	 : new Date('5.12'),
				toDate		 : new Date('5.12'),
				description  : `The Day was proclaimed by the UN General Assembly in 1993 with resolution A/RES/47/237 and reflects the importance the international community attaches to families`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`FamilyDay`],
					keywords : `family day`,
					google   : `International Day of Families`
				}
			},
			{
				dateStr 	 : `May 16th`,
				eventName 	 : `Love a Tree Day`,
				fromDate	 : new Date('5.16'),
				toDate		 : new Date('5.16'),
				description  : `National Love a Tree Day celebrates the wonderful gifts trees give. Set in the middle of Garden for Wildlife Month, the observance encourages us to care for trees and plant trees`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`LoveATreeDay`],
					keywords : `tree day`,
					google   : `Love a Tree Day`
				}
			},
			{
				dateStr 	 : `May 17th`,
				eventName 	 : `International Day Against Homophobia and Transphobia`,
				fromDate	 : new Date('5.17'),
				toDate		 : new Date('5.17'),
				description  : `The International Day Against Homophobia, Biphobia and Transphobia aims to coordinate international events that raise awareness of LGBT rights violations and stimulate interest in LGBT rights work worldwide`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`IDAHOT`],
					keywords : `homophobia transphobia day`,
					google   : `International Day Against Homophobia and Transphobia`
				}
			},
			{
				dateStr 	 : `May 21st`,
				eventName 	 : `National Memo Day`,
				fromDate	 : new Date('5.21'),
				toDate		 : new Date('5.21'),
				description  : `National Memo Day celebrates something that has been a sacred (or loathed depending on who you ask…) source of communication within the business world, the memo`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalMemoDay`],
					keywords : `memo day`,
					google   : `National Memo Day`
				}
			},
			{
				dateStr 	 : `May 21st`,
				eventName 	 : `National Bike to Work Day`,
				fromDate	 : new Date('5.21'),
				toDate		 : new Date('5.21'),
				description  : `Bike to Work Day is an annual event that promotes the bicycle as an option for commuting to work (bicycle commuting). Bike Week is the week that includes the Bike-to-Work Day`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`BTWD`],
					keywords : `bike to work`,
					google   : `National Bike to Work Day`
				}
			},
			{
				dateStr 	 : `May 21st`,
				eventName 	 : `Endangered Species Day`,
				fromDate	 : new Date('5.21'),
				toDate		 : new Date('5.21'),
				description  : `This day is celebrated to highlight the increasing need to protect endangered species across the world. The National Endangered Species Day initiative was introduced in 2006`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`EndangeredSpeciesDay`],
					keywords : `endangered species`,
					google   : `Endangered Species Day`
				}
			},
			{
				dateStr 	 : `May 24th`,
				eventName 	 : `National Scavenger Hunt Day`,
				fromDate	 : new Date('5.24'),
				toDate		 : new Date('5.24'),
				description  : `National Scavenger Hunt Day, marking the annual celebration of hunting for a list of items, or solving a series of clues to “win” the game`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalScavengerHuntDay`],
					keywords : `scavenger hunt`,
					google   : `National Scavenger Hunt Day`
				}
			},
			{
				dateStr 	 : `May 27th`,
				eventName 	 : `Heat Awareness Day`,
				fromDate	 : new Date('5.27'),
				toDate		 : new Date('5.27'),
				description  : `National Heat Awareness Day is an effort by the Occupational Safety and Health Administration (OSHA) and the National Weather Service to alert workers, employers, and the public at large about the (preventable) health dangers related to heat, in order to reduce the overall rate of illnesses and deaths caused by it`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NoFryDay`],
					keywords : `heat day`,
					google   : `Heat Awareness Day`
				}
			},
			{
				dateStr 	 : `May 28th`,
				eventName 	 : `Hamburger Day`,
				fromDate	 : new Date('5.28'),
				toDate		 : new Date('5.28'),
				description  : `National Hamburger Day celebrates America's most iconic food. Americans eat over 50 billion burgers a year, so it's only fitting we set aside a whole day for these special sandwiches. Originating in Hamburg, Germany, the hamburger as we know it was developed in Seymour, Wisconsin, a town still famous for its hamburger heroics`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalHamburgerDay`],
					keywords : `hamburger day`,
					google   : `Hamburger Day`
				}
			},
			{
				dateStr 	 : `May 29th`,
				eventName 	 : `Paperclip Day`,
				fromDate	 : new Date('5.29'),
				toDate		 : new Date('5.29'),
				description  : `National Paperclip Day is observed May 29th in America, and its history goes back decades. The first patent for a bent wire paperclip was created in 1867, given to Samuel B. Fay. It was created as a device to hold tickets or tags onto fabric as to not leave holes`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`PaperclipDay`],
					keywords : `paperclip day`,
					google   : `Paperclip Day`
				}
			},
			{
				dateStr 	 : `May 30th`,
				eventName 	 : `Memorial Day (Fourth Monday of May)`,
				fromDate	 : new Date('5.30'),
				toDate		 : new Date('5.30'),
				description  : `Memorial Day is a federal holiday in the United States for mourning the U.S. military personnel who have died while serving in the United States armed forces`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`MemorialDay`, `MDW`],
					keywords : `memorial day`,
					google   : `Memorial Day`
				}
			},
			{
				dateStr 	 : `May 31st`,
				eventName 	 : `World No-Tobacco Day`,
				fromDate	 : new Date('5.31'),
				toDate		 : new Date('5.31'),
				description  : `The World Health Organization (WHO) and global partners celebrate World No Tobacco Day. The annual campaign is an opportunity to raise awareness on the harmful and deadly effects of tobacco use and second-hand smoke exposure, and to discourage the use of tobacco in any form`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NoTobacco`],
					keywords : `no-tobacco day`,
					google   : `World No-Tobacco Day`
				}
			}
		]
	},
	{
		month: {
			number	 : 5,
			name	 : EnumMonth.June
		},
		majorEvent: {
			name	 : `Pride Month`,
			icon	 : {
				style: 'solid',
				name : `rainbow`
			}
		},
		events: [
			{
				dateStr 	 : `June 1st - 30th`,
				eventName 	 : `Pride Month`,
				fromDate	 : new Date('6.1'),
				toDate		 : new Date('6.30'),
				description  : `ay pride or LGBT pride is the promotion of the self-affirmation, dignity, equality, and increased visibility of lesbian, gay, bisexual, and transgender people as a social group. Pride, as opposed to shame and social stigma, is the predominant outlook that bolsters most LGBT rights movements.`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`Pride`],
					keywords : `pride`,
					google   : `Pride Month`
				}
			},
			{
				dateStr 	 : `June 1`,
				eventName 	 : `Global Day of Parents`,
				fromDate	 : new Date('6.1'),
				toDate		 : new Date('6.1'),
				description  : `The UN General Assembly declared the first-ever Global Day of Parents. The day is celebrated to honor parents for their sacrifices, commitment and selfless love`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`GlobalDayOfParents`],
					keywords : `parents day`,
					google   : `Global Day of Parents`
				}
			},
			{
				dateStr 	 : `June 4`,
				eventName 	 : `National Donut Day`,
				fromDate	 : new Date('6.4'),
				toDate		 : new Date('6.4'),
				description  : `National Doughnut Day, or National Donut Day — celebrated in the United States and in some other countries, succeeding the doughnut event created by The Salvation Army in Chicago in 1938 to honor those of their members who served doughnuts to soldiers during World War `,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalDonutDay`],
					keywords : `donut day`,
					google   : `National Donut Day`
				}
			},
			{
				dateStr 	 : `June 5`,
				eventName 	 : `World Environment Day`,
				fromDate	 : new Date('6.5'),
				toDate		 : new Date('6.5'),
				description  : `The United Nations principal vehicle for encouraging awareness and action for the protection of the environment`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldEnvironmentDay`],
					keywords : `environment day`,
					google   : `World Environment Day`
				}
			},
			{
				dateStr 	 : `June 6`,
				eventName 	 : `National Cancer Survivor's Day`,
				fromDate	 : new Date('6.6'),
				toDate		 : new Date('6.6'),
				description  : `National Cancer Survivors Day is a secular holiday celebrated on the first Sunday in June primarily in the United States of America. The day is meant to 'demonstrate that life after a cancer diagnosis can be a reality'`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalCancerDay`],
					keywords : `cancer day`,
					google   : `National Cancer Survivor's Day`
				}
			},
			{
				dateStr 	 : `June 6`,
				eventName 	 : `Higher Education Day`,
				fromDate	 : new Date('6.6'),
				toDate		 : new Date('6.6'),
				description  : `Celebrate by advocating for higher education on your social media sites. Specifically, you can post photos about your education, your future academic goals, or how your education has helped you in your career`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`HigherEducationDay`],
					keywords : `education day`,
					google   : `Higher Education Day`
				}
			},
			{
				dateStr 	 : `June 8`,
				eventName 	 : `World Oceans Day`,
				fromDate	 : new Date('6.8'),
				toDate		 : new Date('6.8'),
				description  : `The concept was originally proposed in 1992 by Canada's International Centre for Ocean Development and the Ocean Institute of Canada at the Earth Summit – UN Conference on Environment and Development in Rio de Janeiro, Brazil`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldOceansDay`],
					keywords : `oceans day`,
					google   : `World Oceans Day`
				}
			},
			{
				dateStr 	 : `June 8`,
				eventName 	 : `Best Friends Day`,
				fromDate	 : new Date('6.8'),
				toDate		 : new Date('6.8'),
				description  : `A day to celebrate friendship and spend some time with your best friend, showing them how much you appreciate them being in your life`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`BestFriendsDay`],
					keywords : `friends day`,
					google   : `Best Friends Day`
				}
			},
			{
				dateStr 	 : `June 13`,
				eventName 	 : `International Children's Day`,
				fromDate	 : new Date('6.13'),
				toDate		 : new Date('6.13'),
				description  : `Children's Day is a commemorative date celebrated annually in honor of children, whose date of observance varies by country. In 1925, International Children's Day was first proclaimed in Geneva during the World Conference on Child Welfare`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`ChildrensDay`],
					keywords : `childrens day`,
					google   : `International Children's Day`
				}
			},
			{
				dateStr 	 : `June 14`,
				eventName 	 : `World Blood Donor Day`,
				fromDate	 : new Date('6.14'),
				toDate		 : new Date('6.14'),
				description  : `The aim is to raise global awareness of the need for safe blood and blood products for transfusion and of the critical contribution voluntary, unpaid blood donors make to national health systems`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`GiveBlood`],
					keywords : `blood donor day`,
					google   : `World Blood Donor Day`
				}
			},
			{
				dateStr 	 : `June 14`,
				eventName 	 : `National Flag Day`,
				fromDate	 : new Date('6.14'),
				toDate		 : new Date('6.14'),
				description  : `Flag Day, also called National Flag Day, in the United States, a day honouring the national flag, observed on June 14. The holiday commemorates the date in 1777 when the United States approved the design for its first national flag`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`FlagDay`],
					keywords : `flag day`,
					google   : `National Flag Day`
				}
			},
			{
				dateStr 	 : `June 19`,
				eventName 	 : `Juneteenth (Freedom Day)`,
				fromDate	 : new Date('6.19'),
				toDate		 : new Date('6.19'),
				description  : `Juneteenth is a federal holiday in the United States commemorating the emancipation of African-American slaves. It is also often observed for celebrating African-American culture. Originating in Galveston, Texas, it has been celebrated annually on June 19 in various parts of the United States since 1865`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`Juneteenth`],
					keywords : `juneteenth`,
					google   : `Juneteenth`
				}
			},
			{
				dateStr 	 : `June 20`,
				eventName 	 : `World Refugee Day`,
				fromDate	 : new Date('6.20'),
				toDate		 : new Date('6.20'),
				description  : `World Refugee Day designed to celebrate and honour refugees from around the world. The day was first established on 20 June 2001, in recognition of the 50th anniversary of the 1951 Convention Relating to the Status of Refugees`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WithRefugees`],
					keywords : `refugee day`,
					google   : `World Refugee Day`
				}
			},
			{
				dateStr 	 : `June 20`,
				eventName 	 : `First Day of Summer`,
				fromDate	 : new Date('6.20'),
				toDate		 : new Date('6.20'),
				description  : `The summer solstice, also known as estival solstice or midsummer, occurs when one of Earth's poles has its maximum tilt toward the Sun. It happens twice yearly, once in each hemisphere`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`FirstDayOfSummer`],
					keywords : `first day summer`,
					google   : `First Day of Summer`
				}
			},
			{
				dateStr 	 : `June 20`,
				eventName 	 : `Father's Day`,
				fromDate	 : new Date('6.20'),
				toDate		 : new Date('6.20'),
				description  : `Father's Day is a holiday of honoring fatherhood and paternal bonds, as well as the influence of fathers in society. In Catholic countries of Europe, it has been celebrated on 19 March as Saint Joseph's Day since the Middle Ages`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`FathersDay`],
					keywords : `fathers day`,
					google   : `Father's Day`
				}
			},
			{
				dateStr 	 : `June 21`,
				eventName 	 : `National Selfie Day`,
				fromDate	 : new Date('6.21'),
				toDate		 : new Date('6.21'),
				description  : `Thanks to social media and the smartphone, June 21st recognizes a form of self-portrait that couldn't exist without them; It's National Selfie Day! We are encouraged to take creative (appropriate) selfies and share them on social media`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalSelfieDay`],
					keywords : `selfie day`,
					google   : `National Selfie Day`
				}
			},
			{
				dateStr 	 : `June 21`,
				eventName 	 : `World Music Day`,
				fromDate	 : new Date('6.21'),
				toDate		 : new Date('6.21'),
				description  : `The Fête de la Musique, also known in English as Music Day, Make Music Day or World Music Day, is an annual music celebration that takes place on 21 June. On Music Day, citizens and residents are urged to play music outside in their neighborhoods or in public spaces and parks`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldMusicDay`],
					keywords : `music day`,
					google   : `World Music Day`
				}
			},
			{
				dateStr 	 : `June 21`,
				eventName 	 : `International Yoga Day`,
				fromDate	 : new Date('6.21'),
				toDate		 : new Date('6.21'),
				description  : `The International Day of Yoga has been celebrated annually on 21 June since 2015, following its inception in the United Nations General Assembly in 2014. Yoga is a physical, mental and spiritual practice which originated in India`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`InternationalYogaDay`],
					keywords : `yoga day`,
					google   : `International Yoga Day`
				}
			},
			{
				dateStr 	 : `June 24`,
				eventName 	 : `National Handshake Day`,
				fromDate	 : new Date('6.24'),
				toDate		 : new Date('6.24'),
				description  : `National Handshake Day is a holiday that takes a closer look at the act of shaking another person's hand`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`HandshakeDay`],
					keywords : `handshake day`,
					google   : `National Handshake Day`
				}
			},
			{
				dateStr 	 : `June 25`,
				eventName 	 : `Take Your Dog to Work Day`,
				fromDate	 : new Date('6.25'),
				toDate		 : new Date('6.25'),
				description  : `Take Your Dog to Work Day was created by Pet Sitters International and first celebrated in 1999. PSI created the day to encourage businesses to allow dogs in the workplace for one Friday each year to celebrate dogs as companions and promote their adoptions from local shelters, rescue groups, and humane societies`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`TakeYourDogToWorkDay`],
					keywords : `dog to work day`,
					google   : `Take Your Dog to Work Day`
				}
			},
			{
				dateStr 	 : `June 27`,
				eventName 	 : `National Sunglasses Day`,
				fromDate	 : new Date('6.27'),
				toDate		 : new Date('6.27'),
				description  : `Brought to life by The Vision Council, the leading trade association for the optical industry, National Sunglasses Day is a commemorative date held annually on June 27 celebrating the importance of wearing shades to protect the eyes from the sun's harsh ultraviolet (UV) rays`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalSunglassesDay`],
					keywords : `sunglasses day`,
					google   : `National Sunglasses Day`
				}
			},
			{
				dateStr 	 : `June 30`,
				eventName 	 : `Social Media Day`,
				fromDate	 : new Date('6.30'),
				toDate		 : new Date('6.30'),
				description  : `World Social Media day to highlight how it has emerged as a key tool for communication. From connecting people from all corners of the world to helping influencers grow their brand and assisting journalists to cover important news events, social media has become a game changer`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`SMDay`],
					keywords : `social media day`,
					google   : `Social Media Day`
				}
			}
		]
	},
	{
		month: {
			number	 : 6,
			name	 : EnumMonth.July
		},
		majorEvent: {
			name	 : `Independence Day`,
			icon	 : {
				style: 'solid',
				name : `flag-usa`
			}
		},
		events: [
			{
				dateStr 	 : `July 1`,
				eventName 	 : `National Postal Worker Day`,
				fromDate	 : new Date('7.1'),
				toDate		 : new Date('7.1'),
				description  : `National Postal Workers Day is celebrated to show appreciation for the postal workers hard work that they put in to deliver our mail and deliveries on time`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalPostalWorkerDay`],
					keywords : `postal day`,
					google   : `National Postal Worker Day`
				}
			},
			{
				dateStr 	 : `July 2`,
				eventName 	 : `World UFO Day`,
				fromDate	 : new Date('7.2'),
				toDate		 : new Date('7.2'),
				description  : `World UFO Day is an awareness day for people to gather together and watch the skies for unidentified flying objects. The day is celebrated by some on June 24, and others on July 2`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldUFODay`],
					keywords : `ufo day`,
					google   : `World UFO Day`
				}
			},
			{
				dateStr 	 : `July 4`,
				eventName 	 : `Independence Day (United States)`,
				fromDate	 : new Date('7.4'),
				toDate		 : new Date('7.4'),
				description  : `Independence Day is a federal holiday in the United States commemorating the Declaration of Independence of the United State`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`IndependenceDayUSA`],
					keywords : `independence day`,
					google   : `Independence Day (United States)`
				}
			},
			{
				dateStr 	 : `July 7`,
				eventName 	 : `World Chocolate Day`,
				fromDate	 : new Date('7.7'),
				toDate		 : new Date('7.7'),
				description  : `World Chocolate Day, sometimes referred to as International Chocolate Day, or just Chocolate Day, is an annual celebration of chocolate, occurring globally on July 7, which some suggest to be the anniversary of the introduction of chocolate to Europe in 1550. The observance of World Chocolate Day dates back to 2009`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldChocolateDay`],
					keywords : `chocolate day`,
					google   : `World Chocolate Day`
				}
			},
			{
				dateStr 	 : `July 11`,
				eventName 	 : `Cheer Up the Lonely Day`,
				fromDate	 : new Date('7.11'),
				toDate		 : new Date('7.11'),
				description  : `National Cheer Up The Lonely Day hopes to spread awareness about the adverse and long-term effects of loneliness`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`CheerUpTheLonelyDay`],
					keywords : `cheer up day`,
					google   : `Cheer Up the Lonely Day`
				}
			},
			{
				dateStr 	 : `July 12`,
				eventName 	 : `Malala Day`,
				fromDate	 : new Date('7.12'),
				toDate		 : new Date('7.12'),
				description  : `In honour of the young activist Malala Yousafzai, the United Nations declared 12 July, which is also her birthday as Malala Day to support world education. The day is observed to appeal to the world leaders that they ensure compulsory and free education for every child`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`MalalaDay`],
					keywords : `malala day`,
					google   : `Malala Day`
				}
			},
			{
				dateStr 	 : `July 15`,
				eventName 	 : `Give Something Away Day`,
				fromDate	 : new Date('7.15'),
				toDate		 : new Date('7.15'),
				description  : `History of National Give Something Away Day, The day encourages people to give freely to others without expecting anything in return`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`GiveSomethingAwayDay`],
					keywords : `give day`,
					google   : `Give Something Away Day`
				}
			},
			{
				dateStr 	 : `July 15`,
				eventName 	 : `Get to Know Your Customers Day`,
				fromDate	 : new Date('7.15'),
				toDate		 : new Date('7.15'),
				description  : `While the origin of Get to Know Your Customers Day is unknown, the significance of its purpose is fully understood. Businesses thrive on the repeated patronage of their customers. Get to Know Your Customers Day is the quarterly reminder that prompts companies to understand the needs and opinions of their customer base`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`GetToKnowYourCustomersDay`],
					keywords : `customers day`,
					google   : `Get to Know Your Customers Day`
				}
			},
			{
				dateStr 	 : `July 17`,
				eventName 	 : `World Emoji Day`,
				fromDate	 : new Date('7.17'),
				toDate		 : new Date('7.17'),
				description  : `World Emoji Day is an annual unofficial holiday occurring on 17 July, intended to celebrate emoji; in the years since the earliest observance, it has become a popular date to make product or other announcements and releases relating to emoji`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldEmojiDay`],
					keywords : `emoji day`,
					google   : `World Emoji Day`
				}
			},
			{
				dateStr 	 : `July 18`,
				eventName 	 : `Nelson Mandela International Day`,
				fromDate	 : new Date('7.18'),
				toDate		 : new Date('7.18'),
				description  : `Nelson Mandela International Day is an annual international day in honour of Nelson Mandela, celebrated each year on 18 July, Mandela's birthday`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`MandelaDay`],
					keywords : `nelson mandela`,
					google   : `Nelson Mandela International Day`
				}
			},
			{
				dateStr 	 : `July 30`,
				eventName 	 : `Talk in an Elevator Day`,
				fromDate	 : new Date('7.30'),
				toDate		 : new Date('7.30'),
				description  : `This day encourages people to make conversation with others while traveling in an elevator`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`TalkInAnElevatorDay`],
					keywords : `elevator day`,
					google   : `Talk in an Elevator Day`
				}
			},
			{
				dateStr 	 : `July 30`,
				eventName 	 : `International Day of Friendship`,
				fromDate	 : new Date('7.30'),
				toDate		 : new Date('7.30'),
				description  : `Friendship Day is a day in several countries for celebrating friendship. It was initially promoted by the greeting cards' industry; evidence from social networking sites shows a revival of interest in the holiday that may have grown with the spread of the Internet, particularly in India, Bangladesh, and Malaysia`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`DayOfFriendship`],
					keywords : `friendship day`,
					google   : `International Day of Friendship`
				}
			}
		]
	},
	{
		month: {
			number	 : 7,
			name	 : EnumMonth.August
		},
		majorEvent: {
			name	 : `Women's Equality Day`,
			icon	 : {
				style: 'solid',
				name : `person-dress`
			}
		},
		events: [
			{
				dateStr 	 : `August 1st`,
				eventName 	 : `Respect for Parents Day`,
				fromDate	 : new Date('8.1'),
				toDate		 : new Date('8.1'),
				description  : `Respect for Parents Day is for recognizing the significant roles and contribution of parents in a child's life as well as in building a healthy society. Parents not only provide their children love and care but they also give a sense of security and shape their life as well`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`RespectForParentsDay`],
					keywords : `parents day`,
					google   : `Respect for Parents Day`
				}
			},
			{
				dateStr 	 : `August 2nd`,
				eventName 	 : `National Coloring Book Day`,
				fromDate	 : new Date('8.2'),
				toDate		 : new Date('8.2'),
				description  : `National Coloring Book Day recognizes the joy children and adults alike derive from coloring in pages of designs`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalColoringBookDay`],
					keywords : `coloring book`,
					google   : `National Coloring Book Day`
				}
			},
			{
				dateStr 	 : `August 8th`,
				eventName 	 : `International Cat Day`,
				fromDate	 : new Date('8.8'),
				toDate		 : new Date('8.8'),
				description  : `International Cat Day is a celebration which takes place on 8 August of every year. It was created in 2002 by the International Fund for Animal Welfare. It is a day to raise awareness for cats and learn about ways to help and protect them`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`InternationalCatDay`],
					keywords : `cat day`,
					google   : `International Cat Day`
				}
			},
			{
				dateStr 	 : `August 9th`,
				eventName 	 : `National Book Lovers Day`,
				fromDate	 : new Date('8.9'),
				toDate		 : new Date('8.9'),
				description  : `Book Lovers Day is celebrated on August 9 every year. This is an unofficial holiday observed to encourage bibliophiles to celebrate reading and literature. People are advised to put away their smartphones and every possible technological distraction and pick up a book to rea`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalBookLoversDay`],
					keywords : `book day`,
					google   : `National Book Lovers Day`
				}
			},
			{
				dateStr 	 : `August 10th`,
				eventName 	 : `National Lazy Day`,
				fromDate	 : new Date('8.10'),
				toDate		 : new Date('8.10'),
				description  : `National Lazy Day gives us permission to relax and kick back. So, we're going to be a bit lazy here. As you can see, there is not much information regarding this annually celebrated holiday as we do not feel like doing any research`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`LazyDay`],
					keywords : `lazy day`,
					google   : `National Lazy Day`
				}
			},
			{
				dateStr 	 : `August 11th`,
				eventName 	 : `National Sons and Daughters Day`,
				fromDate	 : new Date('8.11'),
				toDate		 : new Date('8.11'),
				description  : `National Son and Daughter Day, a day for parents to show the love they have for their children, whether they're still kids or already grown-up, and spend some time with them making new memories`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`SonsAndDaughtersDay`],
					keywords : `son daughter day`,
					google   : `National Sons and Daughters Day`
				}
			},
			{
				dateStr 	 : `August 12th`,
				eventName 	 : `International Youth Day`,
				fromDate	 : new Date('8.12'),
				toDate		 : new Date('8.12'),
				description  : `International Youth Day is an awareness day designated by the United Nations. The purpose of the day is to draw attention to a given set of cultural and legal issues surrounding youth`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`YouthDay`],
					keywords : `youth day`,
					google   : `International Youth Day`
				}
			},
			{
				dateStr 	 : `August 12th`,
				eventName 	 : `World Elephant Day`,
				fromDate	 : new Date('8.12'),
				toDate		 : new Date('8.12'),
				description  : `World Elephant Day is celebrated to help protect elephants for maintaining the biodiversity of rainForests. This day is marked by raising awareness about the difficulty of the elephants in the forests and also finding out possible ways to protect them`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldElephantDay`],
					keywords : `elephant day`,
					google   : `World Elephant Day`
				}
			},
			{
				dateStr 	 : `August 13th`,
				eventName 	 : `International Lefthanders Day`,
				fromDate	 : new Date('8.13'),
				toDate		 : new Date('8.13'),
				description  : `International Left Handers Day is an international day to celebrate the uniqueness and differences of left-handed individuals. The day was first observed in 1976 by Dean R. Campbell, founder of Lefthanders International, Inc`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`LefthandersDay`],
					keywords : `lefthanders day`,
					google   : `International Lefthanders Day`
				}
			},
			{
				dateStr 	 : `August 15th`,
				eventName 	 : `National Relaxation Day`,
				fromDate	 : new Date('8.15'),
				toDate		 : new Date('8.15'),
				description  : `National Relaxation Day on August 15th encourages us to slow down and unwind. It's a day to focus on taking care of ourselves and take a moment to relax. National Relaxation Day is an important day as we all need a break from the fast-paced and often hectic lifestyles we live`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalRelaxationDay`],
					keywords : `relaxation day`,
					google   : `National Relaxation Day`
				}
			},
			{
				dateStr 	 : `August 16th`,
				eventName 	 : `National Tell a Joke Day`,
				fromDate	 : new Date('8.16'),
				toDate		 : new Date('8.16'),
				description  : `This day will be filled with smiles and laughter from morning till night. Jokes consist of humorous stories, either written or verbal, that often end with a punchline. While slapstick includes props and even minor stunts on the part of the storyteller, the best jokes are usually short. They involve a little misdirection and a well-delivered punchline. The more jokes you tell, the more fun you will have, and so will those around you`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalTellAJokeDay`],
					keywords : `joke day`,
					google   : `National Tell a Joke Day`
				}
			},
			{
				dateStr 	 : `August 19th`,
				eventName 	 : `World Photo Day`,
				fromDate	 : new Date('8.19'),
				toDate		 : new Date('8.19'),
				description  : `World Photography Day is an annual, worldwide celebration of the art, craft, science and history of photography`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldPhotoDay`],
					keywords : `photo day`,
					google   : `World Photo Day`
				}
			},
			{
				dateStr 	 : `August 19th`,
				eventName 	 : `World Humanitarian Day`,
				fromDate	 : new Date('8.19'),
				toDate		 : new Date('8.19'),
				description  : `World Humanitarian Day is an international day dedicated to recognize humanitarian personnel and those who have lost their lives working for humanitarian causes`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldHumanitarianDay`],
					keywords : `humanitarian day`,
					google   : `World Humanitarian Day`
				}
			},
			{
				dateStr 	 : `August 20th`,
				eventName 	 : `National Lemonade Day`,
				fromDate	 : new Date('8.20'),
				toDate		 : new Date('8.20'),
				description  : `National Lemonade Day celebrates the long-standing tradition of drinking lemonade and opening lemonade stands. It encourages others to celebrate too, by supporting these children in their business`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalLemonadeDay`],
					keywords : `lemonade day`,
					google   : `National Lemonade Day`
				}
			},
			{
				dateStr 	 : `August 26th`,
				eventName 	 : `National Dog Day`,
				fromDate	 : new Date('8.26'),
				toDate		 : new Date('8.26'),
				description  : `National Dog Day encourages dog ownership of all breeds. While seeking a new companion, be sure to consider the mutts, mixes, purebreds, and everything in between. Whether mixed or purebred, embrace the opportunity for all dogs to live a happy, safe, and abuse-free life. They all give us companionship`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalDogDay`],
					keywords : `dog day`,
					google   : `National Dog Day`
				}
			},
			{
				dateStr 	 : `August 26th`,
				eventName 	 : `National Women's Equality Day`,
				fromDate	 : new Date('8.26'),
				toDate		 : new Date('8.26'),
				description  : `Women's Equality Day is celebrated in the United States to commemorate the 1920 adoption of the Nineteenth Amendment to the United States Constitution, which prohibits the states and the federal government from denying the right to vote to citizens of the United States on the basis of sex`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`WomensEqualityDay`],
					keywords : `women equality`,
					google   : `National Women's Equality Day`
				}
			}
		]

	},
	{
		month: {
			number	 : 8,
			name	 : EnumMonth.September
		},
		majorEvent: {
			name	 : `Hispanic Heritage Month`,
			icon	 : {
				style: 'solid',
				name : `landmark`
			}
		},
		events: [
			{
				dateStr 	 : `September 4th`,
				eventName 	 : `National Wildlife Day`,
				fromDate	 : new Date('9.4'),
				toDate		 : new Date('9.4'),
				description  : `America marks National Wildlife Day on September 4. It's an opportunity for everyone to step back, take a deep breath and think about all that surrounds us. It inspiring to consider preservation and conservation efforts that work to improve the natural world. There remains so much to learn`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalWildlifeDay`],
					keywords : `wildlife day`,
					google   : `National Wildlife Day`
				}
			},
			{
				dateStr 	 : `September 5th`,
				eventName 	 : `International Day of Charity`,
				fromDate	 : new Date('9.5'),
				toDate		 : new Date('9.5'),
				description  : `The date of 5 September was chosen in order to commemorate the anniversary of the passing away of Mother Teresa of Calcutta, who received the Nobel Peace Prize in 1979 'for work undertaken in the struggle to overcome poverty and distress, which also constitute a threat to peace.`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`CharityDay`],
					keywords : `charity day`,
					google   : `International Day of Charity`
				}
			},
			{
				dateStr 	 : `September 6th`,
				eventName 	 : `Labor Day`,
				fromDate	 : new Date('9.6'),
				toDate		 : new Date('9.6'),
				description  : `Labor Day is a federal holiday in the United States celebrated on the first Monday in September to honor and recognize the American labor movement and the works and contributions of laborers to the development and achievements of the United States. The three-day weekend it falls on is called Labor Day Weekend`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`LaborDay`],
					keywords : `labor day`,
					google   : `Labor Day`
				}
			},
			{
				dateStr 	 : `September 6th`,
				eventName 	 : `Read a Book Day`,
				fromDate	 : new Date('9.6'),
				toDate		 : new Date('9.6'),
				description  : `National Read a Book Day on September 6 calls all book lovers to indulge in their favorite hobby, guilt-free. ... In a world deluged by technology, National Read a Book Day encourages us to silence the noise and turn the pages for a while`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`ReadABookDay`],
					keywords : `book day`,
					google   : `Read a Book Day`
				}
			},
			{
				dateStr 	 : `September 8th`,
				eventName 	 : `International Literacy Day`,
				fromDate	 : new Date('9.8'),
				toDate		 : new Date('9.8'),
				description  : `International Literacy Day is an international observance, celebrated each year on 8 September, that was declared by UNESCO on 26 October 1966 at the 14th session of UNESCO's General Conference. It was celebrated for the first time in 1967`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`LiteracyDay`],
					keywords : `literacy day`,
					google   : `International Literacy Day`
				}
			},
			{
				dateStr 	 : `September 10th`,
				eventName 	 : `Stand Up To Cancer Day`,
				fromDate	 : new Date('9.10'),
				toDate		 : new Date('9.10'),
				description  : `Stand Up To Cancer Day is a day for creating cancer awareness. It is also a time to support the fight against cancer, using various means`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`KissCancerGoodbye`],
					keywords : `cancer day`,
					google   : `Stand Up To Cancer Day`
				}
			},
			{
				dateStr 	 : `September 11th`,
				eventName 	 : `National Day of Service and Remembrance`,
				fromDate	 : new Date('9.11'),
				toDate		 : new Date('9.11'),
				description  : `The September 11 National Day of Service and Remembrance (9/11 Day), is a chance to help others in tribute to those killed and injured on September 11, 2001, first responders, and the countless others who serve to defend the nation's freedom at home and around the globe`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`911Day`],
					keywords : `service remembrance day`,
					google   : `National Day of Service and Remembrance`
				}
			},
			{
				dateStr 	 : `September 12th`,
				eventName 	 : `Civic Day of Hacking`,
				fromDate	 : new Date('9.12'),
				toDate		 : new Date('9.12'),
				description  : `Code for America will host our ninth annual National Day of Civic Hacking. Civic hacking is a term that's evolved a lot since it first debuted. Gone are the days when this exclusively meant building scripts in Excel, writing code, and engineering app solutions`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`HackForChange`],
					keywords : `hacking day`,
					google   : `Civic Day of Hacking`
				}
			},
			{
				dateStr 	 : `September 12th`,
				eventName 	 : `National Grandparents Day`,
				fromDate	 : new Date('9.12'),
				toDate		 : new Date('9.12'),
				description  : `Grandparents' Day or National Grandparents' Day is a secular holiday celebrated in various countries, It is celebrated to show the bond between grandparents and grandchildren. It occurs on various days of the year, either as one holiday or sometimes as a separate Grandmothers' Day and Grandfathers' Day`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalGrandparentsDay`],
					keywords : `grandparents day`,
					google   : `National Grandparents Day`
				}
			},
			{
				dateStr 	 : `September 12th`,
				eventName 	 : `National Day of Encouragement`,
				fromDate	 : new Date('9.12'),
				toDate		 : new Date('9.12'),
				description  : `This day is dedicated to uplifting people around us and making a positive impact. Encouragement is free. It never costs us anything to say a few words to inspire a student, coworker, or friend`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`DayOfEncouragement`],
					keywords : `encouragement day`,
					google   : `National Day of Encouragement`
				}
			},
			{
				dateStr 	 : `September 12th`,
				eventName 	 : `National Video Games Day`,
				fromDate	 : new Date('9.12'),
				toDate		 : new Date('9.12'),
				description  : `National Video Games Day celebrates all the ways we enjoy a good video game challenge`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`NationalVideoGamesDay`],
					keywords : `game day`,
					google   : `National Video Games Day`
				}
			},
			{
				dateStr 	 : `September 15 - October 15th`,
				eventName 	 : `Hispanic Heritage Month`,
				fromDate	 : new Date('9.15'),
				toDate		 : new Date('10.15'),
				description  : `National Hispanic Heritage Month is annually celebrated from September 15 to October 15 in the United States for recognizing the contributions and influence of Hispanic Americans to the history, culture, and achievements of the United States`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`hispanicHeritageMonth`],
					keywords : `hispanic heritage`,
					google   : `Hispanic Heritage Month`
				}
			},
			{
				dateStr 	 : `September 19th`,
				eventName 	 : `Talk Like a Pirate Day`,
				fromDate	 : new Date('9.19'),
				toDate		 : new Date('9.19'),
				description  : `International Talk Like a Pirate Day is a parodic holiday created in 1995 by John Baur and Mark Summers, of Albany, Oregon, U.S., who proclaimed September 19 each year as the day when everyone in the world should talk like a pirate`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`TalkLikeAPirateDay`],
					keywords : `pirate day`,
					google   : `Talk Like a Pirate Day`
				}
			},
			{
				dateStr 	 : `September 21st`,
				eventName 	 : `International Day of Peace`,
				fromDate	 : new Date('9.21'),
				toDate		 : new Date('9.21'),
				description  : `Each year the International Day of Peace is observed around the world on 21 September. The UN General Assembly has declared this as a day devoted to strengthening the ideals of peace, through observing 24 hours of non-violence and cease-fire`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`PeaceDay`],
					keywords : `peace day`,
					google   : `International Day of Peace`
				}
			},
			{
				dateStr 	 : `September 21st`,
				eventName 	 : `Miniature Golf Day`,
				fromDate	 : new Date('9.21'),
				toDate		 : new Date('9.21'),
				description  : `Miniature Golf Day is celebrated worldwide on September 21, not to be confused with National Miniature Golf Day celebrated on the second Saturday in May, in the United States. Miniature golf can be traced back to the 19th century`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`MiniGolfDay`],
					keywords : `miniature golf`,
					google   : `Miniature Golf Day`
				}
			},
			{
				dateStr 	 : `September 22nd`,
				eventName 	 : `Car-Free Day`,
				fromDate	 : new Date('9.22'),
				toDate		 : new Date('9.22'),
				description  : `World Car Free Day, which is celebrated on September 22, encourages motorists to give up their cars for a day. Organized events are held in some cities and countries. The events, which vary by location, give motorists and commuters an idea of their locality with fewer cars`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`CarFreeDay`],
					keywords : `car free day`,
					google   : `Car-Free Day`
				}
			},
			{
				dateStr 	 : `September 22nd`,
				eventName 	 : `Hobbit Day`,
				fromDate	 : new Date('9.22'),
				toDate		 : new Date('9.22'),
				description  : `Hobbit Day is a name used for September 22 in reference to its being the birthday of the hobbits Bilbo and Frodo Baggins, two fictional characters in J. R. R. Tolkien's popular set of books The Hobbit and The Lord of the Rings`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`HobbitDay`],
					keywords : `hobbit day`,
					google   : `Hobbit Day`
				}
			},
			{
				dateStr 	 : `September 22nd`,
				eventName 	 : `First Day of Fall`,
				fromDate	 : new Date('9.22'),
				toDate		 : new Date('9.22'),
				description  : `The autumnal equinox, usually occurring on September 22 or 23, means fall is officially here. The autumnal equinox is one of only two days—the other is the spring, or vernal, equinox—when the Sun is directly above the Equator, ostensibly dividing night and day into equal portions`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`FirstDayOfFall`],
					keywords : `first day of fall`,
					google   : `First Day of Fall`
				}
			},
			{
				dateStr 	 : `September 26th`,
				eventName 	 : `National Pancake Day`,
				fromDate	 : new Date('9.26'),
				toDate		 : new Date('9.26'),
				description  : `National Pancake Day's humble beginnings in 2005, originally started as Lumberjack Day because these are men who need a filling breakfast`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalPancakeDay`],
					keywords : `pancake day`,
					google   : `National Pancake Day`
				}
			},
			{
				dateStr 	 : `September 26th`,
				eventName 	 : `European Day of Languages`,
				fromDate	 : new Date('9.26'),
				toDate		 : new Date('9.26'),
				description  : `The European Day of Languages is observed 26 September, as proclaimed by the Council of Europe on 6 December 2001, at the end of the European Year of Languages, which had been jointly organised by the Council of Europe and the European Union. Its aim is to encourage language learning across Europe`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`EDL`],
					keywords : `europe language day`,
					google   : `European Day of Languages`
				}
			},
			{
				dateStr 	 : `September 27th`,
				eventName 	 : `World Tourism Day`,
				fromDate	 : new Date('9.27'),
				toDate		 : new Date('9.27'),
				description  : `Since 1980, the United Nations World Tourism Organization has celebrated World Tourism Day as international observances on September 27. This date was chosen as on that day in 1970, the Statutes of the UNWTO were adopted. The adoption of these Statutes is considered a milestone in global tourism`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WTD`],
					keywords : `tourism day`,
					google   : `World Tourism Day`
				}
			},
			{
				dateStr 	 : `September 28th`,
				eventName 	 : `World Rabies Day`,
				fromDate	 : new Date('9.28'),
				toDate		 : new Date('9.28'),
				description  : `World Rabies Day is an international awareness campaign coordinated by the Global Alliance for Rabies Control, a non-profit organization with headquarters in the United States`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldRabiesDay`],
					keywords : `rabies day`,
					google   : `World Rabies Day`
				}
			},
			{
				dateStr 	 : `September 28th`,
				eventName 	 : `National Good Neighbor Day`,
				fromDate	 : new Date('9.28'),
				toDate		 : new Date('9.28'),
				description  : `National Good Neighbor Day is a national holiday in the United States celebrated on September 26. In the early 1970s, Becky Mattson of Lakeside, Montana created National Good Neighbor Day as a day to connect with and recognize the importance of strong leaders`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`GoodNeighborDay`],
					keywords : `neighbor day`,
					google   : `National Good Neighbor Day`
				}
			},
			{
				dateStr 	 : `September 29th`,
				eventName 	 : `National Women's Health and Fitness Day`,
				fromDate	 : new Date('9.29'),
				toDate		 : new Date('9.29'),
				description  : `To encourage this importance every last Wednesday of September is celebrated as National Women's Health day which will be celebrated on 30th September this year. Let's take a look into a few habits that every woman should include in the lifestyle for healthy living`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`FitnessDay`],
					keywords : `womens health`,
					google   : `National Women's Health and Fitness Day`
				}
			},
			{
				dateStr 	 : `September 30th`,
				eventName 	 : `International Podcast Day`,
				fromDate	 : new Date('9.30'),
				toDate		 : new Date('9.30'),
				description  : `International Podcast Day is your opportunity to reach into the great big world of podcasts and see what they have to offer. Dig around and find your favorite genres from movies, radio, and TV, and you'll find something in the podcast community that fits your interest`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`InternationalPodcastDay`],
					keywords : `podcast day`,
					google   : `International Podcast Day`
				}
			}
		]
	},
	{
		month: {
			number	 : 9,
			name	 : EnumMonth.October
		},
		majorEvent: {
			name	 : `Halloween`,
			icon	 : {
				style: 'solid',
				name : `jack-o-lantern`
			}
		},
		events: [
			{
				dateStr 	 : `October 1st - 31th`,
				eventName 	 : `Breast Cancer Month`,
				fromDate	 : new Date('10.1'),
				toDate		 : new Date('10.31'),
				description  : `Breast Cancer Awareness Month (BCAM), launched in 1985 by the American Cancer Society and Imperial Chemical Industries (now part of AstraZeneca, which makes several breast cancer drugs), was originally intended to encourage women to get regular mammograms`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`BCAM`, `BreastCancerMonth`],
					keywords : `breast cancer`,
					google   : `Breast Cancer Month`
				}
			},
			{
				dateStr 	 : `October 1st`,
				eventName 	 : `International Day of Older Persons`,
				fromDate	 : new Date('10.1'),
				toDate		 : new Date('10.1'),
				description  : `The International Day of Older People is observed on October 1 each year. On December 14, 1990 the United Nations General Assembly voted to establish October 1 as the International Day of Older People as recorded in Resolution 45/106. The holiday was observed for the first time on October 1, 1991`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`UNDOP`],
					keywords : `older persons day`,
					google   : `International Day of Older Persons`
				}
			},
			{
				dateStr 	 : `October 1st`,
				eventName 	 : `International Coffee Day`,
				fromDate	 : new Date('10.1'),
				toDate		 : new Date('10.1'),
				description  : `International Coffee Day is an occasion that is used to promote and celebrate coffee as a beverage, with events now occurring in places around the world. The first official date was 1 October 2015, as agreed by then International Coffee Organization and was launched in Milan`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`InternationalCoffeeDay`],
					keywords : `coffee day`,
					google   : `International Coffee Day`
				}
			},
			{
				dateStr 	 : `October 1st`,
				eventName 	 : `World Vegetarian Day`,
				fromDate	 : new Date('10.1'),
				toDate		 : new Date('10.1'),
				description  : `World Vegetarian Day is observed annually around the planet on October 1. It is a day of celebration established by the North American Vegetarian Society in 1977 and endorsed by the International Vegetarian Union in 1978, 'To promote the joy, compassion and life-enhancing possibilities of vegetarianism.`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldVegetarianDay`],
					keywords : `vegetarian day`,
					google   : `World Vegetarian Day`
				}
			},
			{
				dateStr 	 : `October 1st`,
				eventName 	 : `World Smile Day`,
				fromDate	 : new Date('10.1'),
				toDate		 : new Date('10.1'),
				description  : `The possibility of World Smile Day was authored and started by Harvey Ball who was a business craftsman from Worcester in Massachusetts. He is known to have made the Smiley Face in the year 1963`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldSmileDay`],
					keywords : `smile day`,
					google   : `World Smile Day`
				}
			},
			{
				dateStr 	 : `October 2nd`,
				eventName 	 : `International Day of Nonviolence`,
				fromDate	 : new Date('10.2'),
				toDate		 : new Date('10.2'),
				description  : `International Day of Non-Violence is observed on 2 October, the birthday of Mahatma Gandhi. It was established on 15 June 2007 according to United Nations General Assembly resolution A/RES/61/271`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`InternationalDayOfNonviolence`],
					keywords : `nonviolence day`,
					google   : `International Day of Nonviolence`
				}
			},
			{
				dateStr 	 : `October 3rd`,
				eventName 	 : `National Techies Day`,
				fromDate	 : new Date('10.3'),
				toDate		 : new Date('10.3'),
				description  : `National Techies Day is observed on October 3 it's meant to celebrate techies or tech-savvy people. This annual commemoration held on the third day of the tenth month of the year is a day devoted to promoting careers in technology among young people`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`TechiesDay`],
					keywords : `techies day`,
					google   : `National Techies Day`
				}
			},
			{
				dateStr 	 : `October 4th`,
				eventName 	 : `World Animal Day`,
				fromDate	 : new Date('10.4'),
				toDate		 : new Date('10.4'),
				description  : `World Animal Day is an international day of action for animal rights and welfare celebrated annually on October 4, the feast day of Francis of Assisi, the patron saint of animals. The World Animal Day movement is supported and endorsed by a number of celebrities, such as Anneka Svenska, Brian Blessed and Melanie C`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldAnimalDay`],
					keywords : `animal day`,
					google   : `World Animal Day`
				}
			},
			{
				dateStr 	 : `October 4th`,
				eventName 	 : `National Taco Day`,
				fromDate	 : new Date('10.4'),
				toDate		 : new Date('10.4'),
				description  : `On October 4th, the day recognizes the savory tortilla stuffed with fillings. It doesn't have to be Tuesday, so get out and enjoy your favorite. The history of tacos predates the arrival of Europeans in Mexico`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`NationalTacoDay`],
					keywords : `taco day`,
					google   : `National Taco Day`
				}
			},
			{
				dateStr 	 : `October 4th`,
				eventName 	 : `World Habitat Day`,
				fromDate	 : new Date('10.4'),
				toDate		 : new Date('10.4'),
				description  : `World Habitat Day is marked on the first Monday of October each year, and is recognized by the United Nations to reflect on the state of towns and cities, and on the basic right of all to adequate shelter`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldHabitatDay`],
					keywords : `habitat day`,
					google   : `World Habitat Day`
				}
			},
			{
				dateStr 	 : `October 5th`,
				eventName 	 : `World Teachers Day`,
				fromDate	 : new Date('10.5'),
				toDate		 : new Date('10.5'),
				description  : `World Teachers' Day, also known as International Teachers Day, is an international day held annually on 5 October. This recommendation outlines standards relating to education personnel policy, recruitment, and initial training as well as the continuing education of teachers, their employment, and working conditions`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldTeachersDay`],
					keywords : `teachers day`,
					google   : `World Teachers Day`
				}
			},
			{
				dateStr 	 : `October 10th`,
				eventName 	 : `World Mental Health Day`,
				fromDate	 : new Date('10.10'),
				toDate		 : new Date('10.10'),
				description  : `World Mental Health Day is an international day for global mental health education, awareness and advocacy against social stigma. It was first celebrated in 1992 at the initiative of the World Federation for Mental Health, a global mental health organization with members and contacts in more than 150 countries`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`WorldMentalHeathDay`],
					keywords : `mental health day`,
					google   : `World Mental Health Day`
				}
			},
			{
				dateStr 	 : `October 11th`,
				eventName 	 : `International Day of the Girl`,
				fromDate	 : new Date('10.11'),
				toDate		 : new Date('10.11'),
				description  : `International Day of the Girl Child is an international observance day declared by the United Nations; it is also called the Day of Girls and the International Day of the Girl. October 11, 2012, was the first Day of the Girl Child`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`DayOfTheGirl`],
					keywords : `girl day`,
					google   : `International Day of the Girl`
				}
			},
			{
				dateStr 	 : `October 14th`,
				eventName 	 : `World Sight Day`,
				fromDate	 : new Date('10.14'),
				toDate		 : new Date('10.14'),
				description  : `World Sight Day is an annual day of awareness held on the second Thursday of October, to focus global attention on vision impairment, including blindness. This year, World Sight Day will take place on October 14, 2021 with the theme: Love Your Eyes`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldSightDay`],
					keywords : `sight day`,
					google   : `World Sight Day`
				}
			},
			{
				dateStr 	 : `October 14th`,
				eventName 	 : `National Dessert Day`,
				fromDate	 : new Date('10.14'),
				toDate		 : new Date('10.14'),
				description  : `National Dessert Day encourages us to celebrate by selecting our favorite delicacies and indulging in them, while also exploring the ever-growing number of options we have to experience in the world of sweets`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`DessertDay`],
					keywords : `dessert day`,
					google   : `National Dessert Day`
				}
			},
			{
				dateStr 	 : `October 15th`,
				eventName 	 : `Global Handwashing Day`,
				fromDate	 : new Date('10.15'),
				toDate		 : new Date('10.15'),
				description  : `Global Handwashing Day is an international handwashing promotion campaign to motivate and mobilize people around the world to improve their handwashing habits. Washing hands at critical points during the day and washing with soap are both important. Global Handwashing Day occurs on 15 October of each year`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`GlobalHandwashingDay`],
					keywords : `handwashing day`,
					google   : `Global Handwashing Day`
				}
			},
			{
				dateStr 	 : `October 16th`,
				eventName 	 : `World Food Day`,
				fromDate	 : new Date('10.16'),
				toDate		 : new Date('10.16'),
				description  : `World Food Day is an international day celebrated every year worldwide on 16 October to commemorate the date of the founding of the United Nations Food and Agriculture Organization in 1945`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`FoodDay`],
					keywords : `food day`,
					google   : `World Food Day`
				}
			},
			{
				dateStr 	 : `October 16th`,
				eventName 	 : `Bosses Day`,
				fromDate	 : new Date('10.16'),
				toDate		 : new Date('10.16'),
				description  : `October 16 is National Boss's Day, a chance to celebrate the people who keep us gainfully employed`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`BossesDay`],
					keywords : `bosses day`,
					google   : `Bosses Day`
				}
			},
			{
				dateStr 	 : `October 17th`,
				eventName 	 : `International Day for the Eradication of Poverty`,
				fromDate	 : new Date('10.17'),
				toDate		 : new Date('10.17'),
				description  : `The International Day for the Eradication of Poverty is an international observance celebrated each year on October 17 throughout the world`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`EndPoverty`],
					keywords : `eradication poverty`,
					google   : `International Day for the Eradication of Poverty`
				}
			},
			{
				dateStr 	 : `October 20th`,
				eventName 	 : `World Statistics Day`,
				fromDate	 : new Date('10.20'),
				toDate		 : new Date('10.20'),
				description  : `World Statistics Day is an international day to celebrate statistics. Created by the United Nations Statistical Commission, it was first celebrated on 20 October 2010. The day is celebrated every five years`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`StatisticsDay`],
					keywords : `statistics day`,
					google   : `World Statistics Day`
				}
			},
			{
				dateStr 	 : `October 21st`,
				eventName 	 : `Reptile Awareness Day`,
				fromDate	 : new Date('10.21'),
				toDate		 : new Date('10.21'),
				description  : `National Reptile Awareness Day is an annual observance celebrated on October 21st of every year. Reptiles are the four-limbed vertebrates that can be seen in many places. It is neither a mammal nor a bird. Reptiles include turtles, crocodilians, frogs, snakes, amphisbaenians, lizards, tuatara, and their family`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`ReptileAwarenessDay`],
					keywords : `reptile day`,
					google   : `Reptile Awareness Day`
				}
			},
			{
				dateStr 	 : `October 21st`,
				eventName 	 : `Get to Know Your Customers Day`,
				fromDate	 : new Date('10.21'),
				toDate		 : new Date('10.21'),
				description  : `While the origin of Get to Know Your Customers Day is unknown, the significance of its purpose is fully understood. Businesses thrive on the repeated patronage of their customers. Get to Know Your Customers Day is the quarterly reminder that prompts companies to understand the needs and opinions of their customer base`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`GetToKnowYourCustomersDay`],
					keywords : `customers day`,
					google   : `Get to Know Your Customers Day`
				}
			},
			{
				dateStr 	 : `October 24th`,
				eventName 	 : `United Nations Day`,
				fromDate	 : new Date('10.24'),
				toDate		 : new Date('10.24'),
				description  : `United Nations Day is an annual commemorative day, reflecting the official creation of the United Nations on 24 October 1945`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`UNDay`],
					keywords : `united nations day`,
					google   : `United Nations Day`
				}
			},
			{
				dateStr 	 : `October 25th`,
				eventName 	 : `Greasy Foods Day`,
				fromDate	 : new Date('10.25'),
				toDate		 : new Date('10.25'),
				description  : `National Greasy Foods Day is the feel good holiday that comes every October 25. It's state fair season: time to fire up the frying oil, chop the potatoes, and break out the napkins. On October 25, you don't have to feel guilty about eating greasy foods, because you're are actually encouraged to`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`GreasyFoodsDay`],
					keywords : `greasy food`,
					google   : `Greasy Foods Day`
				}
			},
			{
				dateStr 	 : `October 30th`,
				eventName 	 : `National Publicist Day`,
				fromDate	 : new Date('10.30'),
				toDate		 : new Date('10.30'),
				description  : `National Publicist Day is celebrated every year on October 30 to appreciate and acknowledge the work public relations professionals do to ensure proper communication reaches the world`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalPublicistDay`],
					keywords : `publicist day`,
					google   : `National Publicist Day`
				}
			},
			{
				dateStr 	 : `October 30th`,
				eventName 	 : `Checklist Day`,
				fromDate	 : new Date('10.30'),
				toDate		 : new Date('10.30'),
				description  : `Checklist Day has been celebrated annually on October 30th of every year. A checklist is a self-made reminder for those living in the fast-moving world. Maintaining a checklist will help the best during emergency times. The day appreciates the value of using checklists and those using them`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`ChecklistDay`],
					keywords : `checklist day`,
					google   : `Checklist Day`
				}
			},
			{
				dateStr 	 : `October 31st`,
				eventName 	 : `Halloween`,
				fromDate	 : new Date('10.31'),
				toDate		 : new Date('10.31'),
				description  : `Halloween, less commonly known as all-halloween, All Hallows' Eve, or All Saints' Eve, is a celebration observed in many countries on 31 October, the eve of the Western Christian feast of All Hallows' Day`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`Halloween`],
					keywords : `halloween`,
					google   : `Halloween`
				}
			}
		]
	},
	{
		month: {
			number	 : 10,
			name	 : EnumMonth.November
		},
		majorEvent: {
			name	 : `Thanksgiving`,
			icon	 : {
				style: 'solid',
				name : `turkey`
			}
		},
		events: [
			{
				dateStr 	 : `November 1st`,
				eventName 	 : `World Vegan Day`,
				fromDate	 : new Date('11.1'),
				toDate		 : new Date('11.1'),
				description  : `World Vegan Day is an annual event celebrated by vegans around the world every 1 November. The benefits of veganism for humans and the natural environment are celebrated through activities such as setting up stalls, hosting potlucks, and planting memorial trees`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldVeganDay`],
					keywords : `vegan day`,
					google   : `World Vegan Day`
				}
			},
			{
				dateStr 	 : `November 1st`,
				eventName 	 : `National Authors Day`,
				fromDate	 : new Date('11.1'),
				toDate		 : new Date('11.1'),
				description  : `November 1 is Author's Day, a day to honor all your favorite authors and to encourage any writers in your life to keep working on their magnum opus. Writing is hard and writing a short story or a book is even harder`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalAuthorsDay`],
					keywords : `authors day`,
					google   : `National Authors Day`
				}
			},
			{
				dateStr 	 : `November 1st`,
				eventName 	 : `National Cook For Your Pets Day`,
				fromDate	 : new Date('11.1'),
				toDate		 : new Date('11.1'),
				description  : `November 1st celebrates National Cook For Your Pets Day. This national holiday encourages cooking something for the pet companion in your life. You love your pet. And you want to provide what is best for them`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`CookForYourPetsDay`],
					keywords : `cook pets day`,
					google   : `National Cook For Your Pets Day`
				}
			},
			{
				dateStr 	 : `November 3rd`,
				eventName 	 : `National Sandwich Day`,
				fromDate	 : new Date('11.3'),
				toDate		 : new Date('11.3'),
				description  : `It's called a 'sandwich', after the earl who came around several hundred years later. And so, National Sandwich Day celebrates both the Earl himself, after whom this food was named, as well as the wonder he brought to the world in the form of what we now know as the sandwich`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalSandwichDay`],
					keywords : `sandwich day`,
					google   : `National Sandwich Day`
				}
			},
			{
				dateStr 	 : `November 4th`,
				eventName 	 : `National Candy Day`,
				fromDate	 : new Date('11.4'),
				toDate		 : new Date('11.4'),
				description  : `National Candy Day is celebrated which is even to pay homage to the sweetness of the candies in our lives`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalCandyDay`],
					keywords : `candy day`,
					google   : `National Candy Day`
				}
			},
			{
				dateStr 	 : `November 6th`,
				eventName 	 : `Daylight Saving Time Ends`,
				fromDate	 : new Date('11.6'),
				toDate		 : new Date('11.6'),
				description  : `Daylight Saving Time ends at 2:00 A.M. clocks are set back one hour (i.e., gaining one hour) to 'fall back.`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`DaylightSavings`],
					keywords : `daylight saving time ends`,
					google   : `Daylight Saving Time Ends`
				}
			},
			{
				dateStr 	 : `November 8th`,
				eventName 	 : `National Cappuccino Day`,
				fromDate	 : new Date('11.8'),
				toDate		 : new Date('11.8'),
				description  : `Italy is delightfully famous for the variety of coffee drinks that it produces. Thus, comes a happy day called National Cappuccino Day, where people from all over can order a frothy and whipped cup of coffee to enjoy on its own or to eat with whatever meal they're having`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`CappuccinoDay`],
					keywords : `cappuccino day`,
					google   : `National Cappuccino Day`
				}
			},
			{
				dateStr 	 : `November 8th`,
				eventName 	 : `Science, Technology, Engineering, and Medicine (STEM) Day`,
				fromDate	 : new Date('11.8'),
				toDate		 : new Date('11.8'),
				description  : `National STEM Day is celebrated every year on Nov. 8 to encourage kids to explore their interests in the fields of science, technology, engineering, art, and math`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`STEMDay`],
					keywords : `stem day`,
					google   : `Science, Technology, Engineering, and Medicine (STEM) Day`
				}
			},
			{
				dateStr 	 : `November 11th`,
				eventName 	 : `Veterans Day`,
				fromDate	 : new Date('11.11'),
				toDate		 : new Date('11.11'),
				description  : `Veterans Day is a federal holiday in the United States observed annually on November 11, for honoring military veterans of the United States Armed Forces`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`VeteransDay`],
					keywords : `veterans day`,
					google   : `Veterans Day`
				}
			},
			{
				dateStr 	 : `November 13th`,
				eventName 	 : `World Kindness Day`,
				fromDate	 : new Date('11.13'),
				toDate		 : new Date('11.13'),
				description  : `World Kindness Day is an international observance on 13 November. It was introduced in 1998 by the World Kindness Movement, a coalition of nations' kindness NGOs. It is observed in many countries, including Canada, Australia, Nigeria and the United Arab Emirates. Singapore observed the day for the first time in 2009`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WKD`],
					keywords : `kindness day`,
					google   : `World Kindness Day`
				}
			},
			{
				dateStr 	 : `November 14th`,
				eventName 	 : `World Diabetes Day`,
				fromDate	 : new Date('11.14'),
				toDate		 : new Date('11.14'),
				description  : `World Diabetes Day is the primary global awareness campaign focusing on diabetes mellitus and is held on 14 November each year`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`WDD`],
					keywords : `diabetes day`,
					google   : `World Diabetes Day`
				}
			},
			{
				dateStr 	 : `November 15th`,
				eventName 	 : `Clean Out Your Refrigerator Day`,
				fromDate	 : new Date('11.15'),
				toDate		 : new Date('11.15'),
				description  : `November 15 is National Clean Out Your Refrigerator Day. While this date may not inspire the same whimsy as National Donut Day or International Talk Like a Pirate Day, it's worth marking on your calendar`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`CleanOutYourRefrigeratorDay`],
					keywords : `refrigerator day`,
					google   : `Clean Out Your Refrigerator Day`
				}
			},
			{
				dateStr 	 : `November 15th`,
				eventName 	 : `America Recycles Day`,
				fromDate	 : new Date('11.15'),
				toDate		 : new Date('11.15'),
				description  : `America Recycles Day, also known as National Recycling Day, is a national observance in the United States dedicated to promoting recycling across the nation`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`BeRecycled`],
					keywords : `recycles day`,
					google   : `America Recycles Day`
				}
			},
			{
				dateStr 	 : `November 16th`,
				eventName 	 : `International Day for Tolerance`,
				fromDate	 : new Date('11.16'),
				toDate		 : new Date('11.16'),
				description  : `The International Day for Tolerance is an annual observance day declared by UNESCO in 1995 to generate public awareness of the dangers of intolerance. It is observed on 16 November`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`ToleranceDay`],
					keywords : `tolerance day`,
					google   : `International Day for Tolerance`
				}
			},
			{
				dateStr 	 : `November 16th`,
				eventName 	 : `National Entrepreneurs Day`,
				fromDate	 : new Date('11.16'),
				toDate		 : new Date('11.16'),
				description  : `On this day, entrepreneurs are encouraged to thank mentors, give funding and advice, and spread the word about how to achieve success in business. People who are not yet successful entrepreneurs might want to read the biography of a particularly successful businessman or woman in order to inspire themselves`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`EntrepreneursDay`],
					keywords : `entrepreneurs day`,
					google   : `National Entrepreneurs Day`
				}
			},
			{
				dateStr 	 : `November 17th`,
				eventName 	 : `International Students Day`,
				fromDate	 : new Date('11.17'),
				toDate		 : new Date('11.17'),
				description  : `Nine students along with the professors were executed without trial on the 17th of November. It is the reason for observing this Day on November 17. The Independent student leaders with the Socialist Union of Youth (SSM/SZM) in 1989 organized a mass demonstration to commemorate International Student's Day`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`InternationalStudentsDay`],
					keywords : `students day`,
					google   : `International Students Day`
				}
			},
			{
				dateStr 	 : `November 19th`,
				eventName 	 : `International Men's Day`,
				fromDate	 : new Date('11.19'),
				toDate		 : new Date('11.19'),
				description  : `International Men's Day is a global holiday celebrated annually on November 19 to recognise and celebrate the cultural, political, and socioeconomic achievements of men. The objectives of celebrating an International Men's Day are set out in 'All The Six Pillars of International Men's Day'`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`InternationalMensDay`],
					keywords : `men day`,
					google   : `International Men's Day`
				}
			},
			{
				dateStr 	 : `November 20th`,
				eventName 	 : `Universal Children's Day`,
				fromDate	 : new Date('11.20'),
				toDate		 : new Date('11.20'),
				description  : `World Children's Day is observed annually on November 20 to commemorate the day of the Declaration of the Rights of the Child by the UN General Assembly on the same day in 1959. It also promotes international togetherness and raises awareness among children to improve their welfare`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`UNChildrensDay`],
					keywords : `childrens day`,
					google   : `Universal Children's Day`
				}
			},
			{
				dateStr 	 : `November 21st`,
				eventName 	 : `World Hello Day`,
				fromDate	 : new Date('11.21'),
				toDate		 : new Date('11.21'),
				description  : `World Hello Day is a secular holiday observed annually on November 21, to express that conflicts should be resolved through communication rather than the use of force. Participants verbally greet ten people or more on that day as an expression of the importance of personal communication in preserving peace`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldHelloDay`],
					keywords : `hello day`,
					google   : `World Hello Day`
				}
			},
			{
				dateStr 	 : `November 25th`,
				eventName 	 : `Thanksgiving Day`,
				fromDate	 : new Date('11.25'),
				toDate		 : new Date('11.25'),
				description  : `Thanksgiving is a national holiday celebrated on various dates in the United States, Canada, Grenada, Saint Lucia, and Liberia. It began as a day of giving thanks for the blessing of the harvest and of the preceding year. Similarly named festival holidays occur in Germany and Japan`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`Thanksgiving`],
					keywords : `thanksgiving day`,
					google   : `Thanksgiving Day`
				}
			},
			{
				dateStr 	 : `November 26th`,
				eventName 	 : `National Cake Day`,
				fromDate	 : new Date('11.26'),
				toDate		 : new Date('11.26'),
				description  : `National Cake Day delivers a scrumptious treat for everyone to enjoy! Slide over pie, this day cake takes center stage as the dessert of choice. On most birthdays, the cake is topped with candles no matter their age. Showers, weddings, retirements and anniversaries, cake serves up a slice or two`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalCakeDay`],
					keywords : `cake day`,
					google   : `National Cake Day`
				}
			},
			{
				dateStr 	 : `November 26th`,
				eventName 	 : `National Day of Listening`,
				fromDate	 : new Date('11.26'),
				toDate		 : new Date('11.26'),
				description  : `The ability to listen is a skill we can practice on National Day of Listening, which is the day after Thanksgiving on November 26, a day to get away from the chaos of the world, just to relax, hear, and be heard`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`DayOfListening`],
					keywords : `listening day`,
					google   : `National Day of Listening`
				}
			},
			{
				dateStr 	 : `November 27th`,
				eventName 	 : `Small Business Saturday (The last Saturday of November)`,
				fromDate	 : new Date('11.27'),
				toDate		 : new Date('11.27'),
				description  : `Small Business Saturday is an annual event that was created to encourage consumers to shop locally in person and online at small businesses. This event takes place every November and represents a significant opportunity to increase sales for small businesses during the holiday shopping season`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`ShopSmall`],
					keywords : `small business`,
					google   : `Small Business Saturday`
				}
			},
			{
				dateStr 	 : `November 29th`,
				eventName 	 : `Electronic Greeting Card Day`,
				fromDate	 : new Date('11.29'),
				toDate		 : new Date('11.29'),
				description  : `Electronic Greetings Day encourages us to send an electronic greeting. At the same time, the day reminds us of how much things have changed. The convenience and speed of sending an electronic greeting allow more people than ever to participate in this thoughtful process`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`ElectronicGreetingCardDay`],
					keywords : `greeting card day`,
					google   : `Electronic Greeting Card Day`
				}
			},
			{
				dateStr 	 : `November 30th`,
				eventName 	 : `Computer Security Day`,
				fromDate	 : new Date('11.30'),
				toDate		 : new Date('11.30'),
				description  : `Computer Security Day is an annual event and is celebrated on the 30th November each year. It is designed to raise awareness and to promote best practices in Information Security`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`ComputerSecurityDay`],
					keywords : `computer security`,
					google   : `Computer Security Day`
				}
			}
		]
	},
	{
		month: {
			number	 : 11,
			name	 : EnumMonth.December
		},
		majorEvent: {
			name	 : `Christmas`,
			icon	 : {
				style: 'solid',
				name : `gifts`
			}
		},
		events: [
			{
				dateStr 	 : `December 1st`,
				eventName 	 : `World AIDS Day`,
				fromDate	 : new Date('12.1'),
				toDate		 : new Date('12.1'),
				description  : `World AIDS Day, designated on 1 December every year since 1988, is an international day dedicated to raising awareness of the AIDS pandemic caused by the spread of HIV infection and mourning those who have died of the disease`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`WAD`],
					keywords : `aids day`,
					google   : `World AIDS Day`
				}
			},
			{
				dateStr 	 : `December 3rd`,
				eventName 	 : `International Day of Persons with Disabilities`,
				fromDate	 : new Date('12.3'),
				toDate		 : new Date('12.3'),
				description  : `International Day of Persons with Disabilities is an international observance promoted by the United Nations since 1992. It has been observed with varying degrees of success around the planet`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`IDPWD`],
					keywords : `disabilities day`,
					google   : `International Day of Persons with Disabilities`
				}
			},
			{
				dateStr 	 : `December 4th`,
				eventName 	 : `National Cookie Day`,
				fromDate	 : new Date('12.4'),
				toDate		 : new Date('12.4'),
				description  : `National Cookie Day is an annual feast celebrated on December 4th of each year. Cookies need no special reason to be eaten and are loved by all sorts of people from child to adult and old. Most of us during our childhood days would have stolen the cookies from the jar without leaving a trace`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NationalCookieDay`],
					keywords : `cookie day`,
					google   : `National Cookie Day`
				}
			},
			{
				dateStr 	 : `December 5th`,
				eventName 	 : `World Soil Day`,
				fromDate	 : new Date('12.5'),
				toDate		 : new Date('12.5'),
				description  : `World Soil Day (WSD) is held annually on 5 December as a means to focus attention on the importance of healthy soil and to advocate for the sustainable management of soil resources. An international day to celebrate soil was recommended by the International Union of Soil Sciences`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WorldSoilDay`],
					keywords : `soil day`,
					google   : `World Soil Day`
				}
			},
			{
				dateStr 	 : `December 6th`,
				eventName 	 : `Microwave Oven Day`,
				fromDate	 : new Date('12.6'),
				toDate		 : new Date('12.6'),
				description  : `National Microwave Oven Day is celebrated on December 6 of every year. It's time to celebrate a day for the microwave, an everyday appliance. Most often, the leftover foods are heated using the microwave oven`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`MicrowaveOvenDay`],
					keywords : `microwave day`,
					google   : `Microwave Oven Day`
				}
			},
			{
				dateStr 	 : `December 8th`,
				eventName 	 : `Pretend to Be a Time Traveler Day`,
				fromDate	 : new Date('12.8'),
				toDate		 : new Date('12.8'),
				description  : `On this day of imagination and time-hopping celebration we pretend that we can move across the years and go wherever we want`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`PretendToBeATimeTravelerDay`],
					keywords : `time traveler`,
					google   : `Pretend to Be a Time Traveler Day`
				}
			},
			{
				dateStr 	 : `December 10th`,
				eventName 	 : `Human Rights Day`,
				fromDate	 : new Date('12.10'),
				toDate		 : new Date('12.10'),
				description  : `Human Rights Day is observed every year on 10 December – the day on which the United Nations General Assembly adopted, in 1948, the Universal Declaration of Human Rights. The Universal Declaration of Human Rights empowers us all. The principles enshrined in the Declaration are as relevant today as they were in 1948`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`HumanRightsDay`],
					keywords : `human rights`,
					google   : `Human Rights Day`
				}
			},
			{
				dateStr 	 : `December 10th`,
				eventName 	 : `Nobel Prize Day`,
				fromDate	 : new Date('12.10'),
				toDate		 : new Date('12.10'),
				description  : `Nobel Prize Day falls on December 10 every year. It honors the achievements of Alfred Bernhard Nobel, a Swedish engineer, chemist, entrepreneur, and philanthropist. We have all heard of the Nobel Prize that recognizes outstanding achievements in various fields in the arts and sciences`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NobelPrize`],
					keywords : `nobel prize`,
					google   : `Nobel Prize Day`
				}
			},
			{
				dateStr 	 : `December 10th`,
				eventName 	 : `National Salesperson Day`,
				fromDate	 : new Date('12.10'),
				toDate		 : new Date('12.10'),
				description  : `It's been celebrated annually since 2000, and its roots lie in the recognition of retail sales associates. Plus, more importantly, we thought we'd provide the first-ever gift guide for you to recognize the members of your prized sales team`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`SalespersonDay`],
					keywords : `salesperson day`,
					google   : `National Salesperson Day`
				}
			},
			{
				dateStr 	 : `December 11th`,
				eventName 	 : `International Mountain Day`,
				fromDate	 : new Date('12.11'),
				toDate		 : new Date('12.11'),
				description  : `December 11 is observed as International Mountain Day to raise awareness of the significance of mountains. The day is also celebrated to highlight the importance of preserving the beauty of mountains across the world`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`InternationalMountainDay`],
					keywords : `mountain day`,
					google   : `International Mountain Day`
				}
			},
			{
				dateStr 	 : `December 21st`,
				eventName 	 : `Crossword Puzzle Day`,
				fromDate	 : new Date('12.21'),
				toDate		 : new Date('12.21'),
				description  : `National Crossword Puzzle Day is celebrated on December 21 to recognize the date of the first known publication of the puzzle. The first crossword puzzles were published in England in newspapers, children's books, and other publications`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`CrosswordPuzzleDay`],
					keywords : `crossword puzzle`,
					google   : `Crossword Puzzle Day`
				}
			},
			{
				dateStr 	 : `December 21st`,
				eventName 	 : `First Day of Winter`,
				fromDate	 : new Date('12.21'),
				toDate		 : new Date('12.21'),
				description  : `The winter solstice of 2021 occurs today (Dec. 21), marking the official beginning of winter in the Northern Hemisphere and it brings good news: From tomorrow on, days will start getting longer again, taking us out of the darkness as we slowly head towards spring`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`WinterSolstice`],
					keywords : `first day of winter`,
					google   : `First Day of Winter`
				}
			},
			{
				dateStr 	 : `December 27th`,
				eventName 	 : `No Interruptions Day`,
				fromDate	 : new Date('12.27'),
				toDate		 : new Date('12.27'),
				description  : `No Interruptions Day. Put up a "Do Not Disturb" sign on your door and ban all interruptions on December 27 because it is No Interruptions Day. Interruptions and distractions can have a big effect on productivity`,
				specialEvent : false,
				search 		 : {
					hashtag  : [`NoInterruptionsDay`],
					keywords : `no interruptions`,
					google   : `No Interruptions Day`
				}
			},
			{
				dateStr 	 : `December 31th`,
				eventName 	 : `New Year's Eve`,
				fromDate	 : new Date('12.31'),
				toDate		 : new Date('12.31'),
				description  : `In the Gregorian calendar, New Year's Eve, also known as Old Year's Day or Saint Sylvester's Day in many countries, the evening or the entire day of the last day of the year, is on 31 December. The last day of the year is commonly referred to as "New Year's Eve"`,
				specialEvent : true,
				search 		 : {
					hashtag  : [`NYE`],
					keywords : `new years eve`,
					google   : `New Year's Eve`
				}
			}
		]
	}
];


/**------------------------------------------------------
 * Intefaces Definations
 */
export interface IMonth {
	name 	  	: EnumMonth;
	isExisting 	: boolean;
}

export interface ISocialHoliday {
	month		: ISocialMonth;
	majorEvent ?: IMajorEvent;
	events		: ISocialEvent[];
}

export interface ISocialMonth {
	number		: number;
	name		: EnumMonth;
}

export interface ISocialEvent {
	dateStr 	 : string;
	eventName 	 : string;
	fromDate	 : Date;
	toDate		 : Date;
	description  : string;
	specialEvent : boolean;
	search		 : ISocialEventSearch;
}

export interface ISocialEventSearch {
	hashtag		: string[];
	keywords	: string;
	google		: string;
}

interface IMajorEvent {
	name		: string;
	icon		: IReferenceIcon;
}
